(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["locker"] && !Shopify.designMode) return;
  try {
    

  var lockerData = []
  var productAjaxRequest = null;
  
  $(document).ready(function() {
    lockerData = $.cookie('locker-data');
    if (lockerData == null) {
      lockerData = [];
    } else {
      lockerData = $.parseJSON($.cookie('locker-data'));   
    }
    displayItems();

    // check for submitted form
    $.urlParam = function(name){
      var results = new RegExp('[\?&]' + name + '=([^]*)').exec(window.location.href);
      if (results==null){
        return null;
      }
      else{
        return results[1] || 0;
      }
    }
	if ($.urlParam('contact_posted') != null) {
	  $.cookie('locker-data', null, { path: '/' });
	};

    // add special values to form before submitting
    $('#contact_form').submit(function(e) {
      // Add items to form value
      var itemsString = '';
      var total = 0;
      $.each(lockerData, function(index,value) {
        itemsString += value.title + ', ' + money(value.price) + ', ' + value.quantity + ', ' + money(value.total) + '\n';
        total += value.total;
      });
      itemsString += 'Total: ' + money(total);
      $('#contactFormItems').val(itemsString);


      // multi select to single value
      var primaryColorElement = $('select[name="primary_colors"]')
      if (primaryColorElement) {
        var primary_color_string = primaryColorElement.val().join(", ");
        $('#primary_color_text').val(primary_color_string);
      }

      // multi select to single value
      var secondaryColorElement = $('select[name="secondary_colors"]')
      if (secondaryColorElement) {
        var secondary_color_string = secondaryColorElement.val().join(", ");
        $('#secondary_color_text').val(secondary_color_string);
      }
      
      //alert(secondary_color_string);
      //alert($('select[name="secondary_colors"]').val());
      //e.preventDefault();
      //alert("submitting")
    });
      // for pantone selector
    var getContrastYIQ, getPantoneColor, pantoneColor, pantoneColorTag, runnerAssociativeArray;
    runnerAssociativeArray = function(array) {
      var key, results, size;
      size = 0;
      results = [];
      for (key in array) {
        if (array.hasOwnProperty(key)) {
          if (array[key]["custom"] == true) {
            $('.pms_select').append('<option value="' + array[key]['name'] + '">' + array[key]['custom_name'] + '</option>');
          	results.push(size++);
          } else {
            $('.pms_select').append('<option value="' + array[key]['name'] + '"> PMS ' + array[key]['name'] + '</option>');
            results.push(size++);
          }
        } else {
          results.push(void 0);
        }
      }

      return results;
    };
    runnerAssociativeArray(pantoneSwatches);
    getContrastYIQ = function($rgb) {
      var rgb, yiq;
      rgb = $rgb.split(',');
      yiq = ((rgb[0] * 299) + (rgb[1] * 587) + (rgb[2] * 114)) / 1000;
      if (yiq >= 128) {
        return "black";
      } else {
        return "white";
      }
    };
    getPantoneColor = function(pantoneName) {
      var b, g, r;
      r = Math.ceil(pantoneSwatches[pantoneName]['r'] * 255);
      g = Math.ceil(pantoneSwatches[pantoneName]['g'] * 255);
      b = Math.ceil(pantoneSwatches[pantoneName]['b'] * 255);
      return r + ',' + g + ',' + b;
    };
    pantoneColor = function(numberPantone) {
      if (!numberPantone.id) {
        return numberPantone.text;
      }
      return $('<span class="pantone-color-block" style="background-color: rgb(' + getPantoneColor("p" + numberPantone.id) + ');">&nbsp;</span><span class="pantone-color-name">' + numberPantone.text + '</span>');
    };
    pantoneColorTag = function(numberPantone) {
      var $color;
      if (!numberPantone.id) {
        return numberPantone.text;
      }
      $color = getPantoneColor("p" + numberPantone.id);
      return $('<span class="pantone-color-block" style="background-color: rgb(' + $color + ');">&nbsp;</span><span class="pantone-color-name" style="color: ' + getContrastYIQ($color) + '">' + numberPantone.text + '</span>');
    };
    $("select.pms_select").select2({
      theme: 'default pallete',
      templateResult: pantoneColor,
      templateSelection: pantoneColorTag,
      maximumSelectionLength: 1,
      width: '100%'
    });
  })
  //alert("on page")

  function displayItems() {
    //alert(lockerData.length);
    var lockerTableArea = $('#locker-items-table')
    if (!lockerTableArea) {
      return
    }
    lockerTableArea.empty();
    if (lockerData.length == 0) {
      $('locker-summary').empty();
      lockerTableArea.append('<p class="quote">There are no items in your locker<br class="clear" /><a href="/pages/how-custom-works">Check out how custom works</a><br class="clear" />');
    } else {
      var newTable = `<table style="width: 100%;"><thead><tr>
                        <th style="width: 100px"></th>
                        <th>Item</th>
                        <th style="width: 100px">Price</th>
                        <th style="width: 100px">Qty</th>
                        <th style="width: 100px">total</th>
                      </tr></thead><tbody>`
      $.each(lockerData, function(index,value) {
        // new row item
        newTable += `<tr>
                        <td><a href="${value.url}" title="${value.title}" class="cart_image"><img src="${value.img}" alt="${value.title}" /></a></td>
                        <td style="vertical-align: middle;"><a href="${value.url}">${value.title}</a></td>
                        <td style="vertical-align: middle;"><span class="unit_price">${money(value.price)}</span></td>
                        <td style="vertical-align: middle;"><input type="number" min="0" size="2" data-handle="${value.handle}" class="quantity" name="updates[]" id="request_updates_${value.id}" value="${value.quantity}" /></td>
                        <td style="vertical-align: middle;"><span class="unit_total">${money(value.total)}</span></td>
                        <td style="vertical-align: middle;"><a href="#" data-handle="${value.handle}" title="Remove" class="remove"><span class="ss-icon">X</span></a></td>
                      </tr>`
        //var $item = $('<li class="itemrow"><div class="eight columns title_column alpha"></div><div class="four columns mobile_right omega"><span class="price_total"><span class="money unit_total">' + money(value.total) + '</span></span></div><div class="sixteen columns clearfix alpha omega"><hr /></div></li>');
        //$list.append($item);
      });
      newTable += "</tbody></table>"
      lockerTableArea.append(newTable);

        $(".remove").click(function(e) {
          e.preventDefault();
          var itemElement = $(this).closest("tr");
          disableItem(itemElement);
          var removeHandle = $(this).data("handle");
          var removeIndex;
          $.each(lockerData, function(index,value) {
            //alert(JSON.stringify(value));
            if (value.handle == removeHandle) {
              removeIndex = index;
              return false;
            }
          });
          if (removeIndex != undefined) {
            lockerData.splice(removeIndex, 1);
            itemElement.remove();
            saveItems();
          } else {
            displayItems();
          }
        });

        $(".quantity").change(function() {
          var itemElement = $(this).closest("tr");
          disableItem(itemElement);

          var updateHandle = $(this).data("handle");
          var itemFound;
          $.each(lockerData, function(index,value) {
            if (value.handle == updateHandle) {
              itemFound = value;
              return false;
            }
          });
          if (itemFound != undefined) {
              getPrice(itemFound, itemElement, $(this).val());
               
              enableItem(itemElement);
              //itemElement.fadeTo(20, 1);
              //displayItems(lockerData);
          } else {
            displayItems();
          }
        });
      updateTotal();

    }
  }
  
  function updateItem(item, $ui_item, quantity, price) {
    var new_total = quantity * price
    item.quantity = quantity;  
    item.price = price;
    item.total = new_total;
    $ui_item.find(".unit_price").text(money(price));
    $ui_item.find(".unit_total").text(money(new_total));
    saveItems();

    //enableItem(itemElement);
    //itemElement.fadeTo(20, 1);
    //displayItems(lockerData);
  };
  
  function getPrice(item, $ui_item, quantity) {
    var use_price = 0;
    productAjaxRequest = $.ajax({
      url: item.url + '.json',
      dataType: "json",
      beforeSend: function() {
        if (productAjaxRequest != null) {
          productAjaxRequest.abort();
        }
      },
      success: function(data) {
        use_price = 0
        var lastQuantity = 0;
        var variant_min_quantity;
        $.each(data.product.variants, function(index,value) {
          // get quantity of variant
          variant_min_quantity = parseInt(value.title.replace('+', ''));
          // if greater than last quantity then grab price
          if (variant_min_quantity <= parseInt(quantity)) {
            use_price = parseFloat(value.price);
          }
        });
        updateItem(item, $ui_item, quantity, use_price)
      }
    });
    return use_price;
  }

  function updateTotal() {
    var total = 0;
    $.each(lockerData, function(index,value) {
      total += value.total;
    });
    $('#subtotal').text(money(total));
  }
  
  function money(price) {
    return '$' + parseFloat(price, 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString();
  }

  function disableItem($item) {
    $item.fadeTo(100, 0.5);
    $item.find(":input").attr("disabled", true);
  }

  function enableItem($item) {
    $item.find(":input").attr("disabled", false);
    $item.fadeTo(100, 1);
  }

  function saveItems() {
    $.cookie("locker-data", JSON.stringify(lockerData), { path: '/' });
    if (lockerData.length == 0) {
      displayItems();
    }
    updateTotal();
    
    //$.each(lockerData, function(index,value) {
    //  alert(value.handle + " with quant: " + value.quantity);
    //});
  }

  var pantoneSwatches = {
    'pJLNAVYBLUE': { name: 'JLNAVYBLUE',r: 0.054901960784314, g: 0.117647058823529, b: 0.141176470588235, custom: true, custom_name: 'JL NAVY BLUE' },
'pJLRED': { name: 'JLRED',r: 0.705882352941177, g: 0.0627450980392157, b: 0.196078431372549, custom: true, custom_name: 'JL RED' },
'pJLFORESTGREEN': { name: 'JLFORESTGREEN',r: 0, g: 0.192156862745098, b: 0.0784313725490196, custom: true, custom_name: 'JL FOREST GREEN' },
'pJLKELLYGREEN': { name: 'JLKELLYGREEN',r: 0, g: 0.631372549019608, b: 0.345098039215686, custom: true, custom_name: 'JL KELLY GREEN' },
'pJLPENNRED': { name: 'JLPENNRED',r: 0.694117647058824, g: 0.172549019607843, b: 0.207843137254902, custom: true, custom_name: 'JL PENN RED' },
'pJLORANGE': { name: 'JLORANGE',r: 0.898039215686275, g: 0.152941176470588, b: 0.145098039215686, custom: true, custom_name: 'JL ORANGE' },
'pJLATHLETICGOLD': { name: 'JLATHLETICGOLD',r: 0.992156862745098, g: 0.776470588235294, b: 0.0980392156862745, custom: true, custom_name: 'JL ATHLETIC GOLD' },
'pJLYELLOW': { name: 'JLYELLOW',r: 1, g: 0.835294117647059, b: 0, custom: true, custom_name: 'JL YELLOW' },
'pJLTEAL': { name: 'JLTEAL',r: 0, g: 0.556862745098039, b: 0.450980392156863, custom: true, custom_name: 'JL TEAL' },
'pJLMETGOLD': { name: 'JLMETGOLD',r: 0.980392156862745, g: 0.901960784313726, b: 0.549019607843137, custom: true, custom_name: 'JL MET GOLD' },
'pJL REGALPURPLE': { name: 'JL REGALPURPLE',r: 0.262745098039216, g: 0.180392156862745, b: 0.529411764705882, custom: true, custom_name: 'JL  REGAL PURPLE' },
'pJLCOLUMBIABLUE': { name: 'JLCOLUMBIABLUE',r: 0.376470588235294, g: 0.698039215686274, b: 0.83921568627451, custom: true, custom_name: 'JL COLUMBIA BLUE' },
'pJLBROWN': { name: 'JLBROWN',r: 0.301960784313725, g: 0.113725490196078, b: 0, custom: true, custom_name: 'JL BROWN' },
'pJLROYALBLUE': { name: 'JLROYALBLUE',r: 0, g: 0.364705882352941, b: 0.552941176470588, custom: true, custom_name: 'JL ROYAL BLUE' },
'pJLROYALBLUE': { name: 'JLROYALBLUE',r: 0, g: 0.364705882352941, b: 0.552941176470588, custom: true, custom_name: 'JL ROYAL BLUE' },
'pJLDOVE': { name: 'JLDOVE',r: 0.835294117647059, g: 0.874509803921569, b: 0.87843137254902, custom: true, custom_name: 'JL DOVE' },
'pJLTURQUOISE': { name: 'JLTURQUOISE',r: 0, g: 0.517647058823529, b: 0.627450980392157, custom: true, custom_name: 'JL TURQUOISE' },
'pJLACADEMYBLUE': { name: 'JLACADEMYBLUE',r: 0, g: 0.474509803921569, b: 0.654901960784314, custom: true, custom_name: 'JL ACADEMY BLUE' },
'pJLMAROON': { name: 'JLMAROON',r: 0.435294117647059, g: 0.0862745098039216, b: 0.129411764705882, custom: true, custom_name: 'JL MAROON' },
'pJLCAMBRIDGEBLUE': { name: 'JLCAMBRIDGEBLUE',r: 0.698039215686274, g: 0.780392156862745, b: 0.67843137254902, custom: true, custom_name: 'JL CAMBRIDGE BLUE' },
'pJLPLATINUM': { name: 'JLPLATINUM',r: 0.435294117647059, g: 0.529411764705882, b: 0.596078431372549, custom: true, custom_name: 'JL PLATINUM' },
'pJLCARBON': { name: 'JLCARBON',r: 0.184313725490196, g: 0.203921568627451, b: 0.290196078431373, custom: true, custom_name: 'JL CARBON' },
'pJLBURGUNDY': { name: 'JLBURGUNDY',r: 0.435294117647059, g: 0.0901960784313725, b: 0.172549019607843, custom: true, custom_name: 'JL BURGUNDY' },
'pJLFUSCHIA': { name: 'JLFUSCHIA',r: 0.890196078431372, g: 0.0588235294117647, b: 0.466666666666667, custom: true, custom_name: 'JL FUSCHIA' },
'pJLLILAC': { name: 'JLLILAC',r: 0.474509803921569, g: 0.447058823529412, b: 0.666666666666667, custom: true, custom_name: 'JL LILAC' },
'pJLBLACK': { name: 'JLBLACK',r: 0, g: 0.0392156862745098, b: 0.0509803921568627, custom: true, custom_name: 'JL BLACK' },
'pJLDEEPWINE': { name: 'JLDEEPWINE',r: 0.270588235294118, g: 0.0823529411764706, b: 0.152941176470588, custom: true, custom_name: 'JL DEEP WINE' },
'pJLBUBBLEGUMPINK': { name: 'JLBUBBLEGUMPINK',r: 0.933333333333333, g: 0.568627450980392, b: 0.690196078431373, custom: true, custom_name: 'JL BUBBLEGUM PINK' },
'pJLTRUEORANGE': { name: 'JLTRUEORANGE',r: 0.913725490196078, g: 0.309803921568627, b: 0.164705882352941, custom: true, custom_name: 'JL TRUE ORANGE' },
'pJLTEXASORANGE': { name: 'JLTEXASORANGE',r: 0.537254901960784, g: 0.231372549019608, b: 0.117647058823529, custom: true, custom_name: 'JL TEXAS ORANGE' },
'pJLNEWLEANDERPINK': { name: 'JLNEWLEANDERPINK',r: 0.905882352941176, g: 0.474509803921569, b: 0.470588235294118, custom: true, custom_name: 'JL NEW LEANDER PINK' },
'pJLSPRUCE': { name: 'JLSPRUCE',r: 0, g: 0.372549019607843, b: 0.317647058823529, custom: true, custom_name: 'JL SPRUCE' },
'pJLFLAWLESSRED': { name: 'JLFLAWLESSRED',r: 0.650980392156863, g: 0.0470588235294118, b: 0.137254901960784, custom: true, custom_name: 'JL FLAWLESS RED' },
	'p100': {
		name: '100',
		r: 0.956862745098039,
		g: 0.929411764705882,
		b: 0.486274509803922
	},
	'p101': {
		name: '101',
		r: 0.956862745098039,
		g: 0.929411764705882,
		b: 0.27843137254902
	},
	'p102': {
		name: '102',
		r: 0.976470588235294,
		g: 0.909803921568627,
		b: 0.0784313725490196
	},
	'p103': {
		name: '103',
		r: 0.776470588235294,
		g: 0.67843137254902,
		b: 0.0588235294117647
	},
	'p104': {
		name: '104',
		r: 0.67843137254902,
		g: 0.607843137254902,
		b: 0.0470588235294118
	},
	'p105': {
		name: '105',
		r: 0.509803921568627,
		g: 0.458823529411765,
		b: 0.0588235294117647
	},
	'p106': {
		name: '106',
		r: 0.968627450980392,
		g: 0.909803921568627,
		b: 0.349019607843137
	},
	'p107': {
		name: '107',
		r: 0.976470588235294,
		g: 0.898039215686275,
		b: 0.149019607843137
	},
	'p108': {
		name: '108',
		r: 0.976470588235294,
		g: 0.866666666666667,
		b: 0.0862745098039216
	},
	'p109': {
		name: '109',
		r: 0.976470588235294,
		g: 0.83921568627451,
		b: 0.0862745098039216
	},
	'p110': {
		name: '110',
		r: 0.847058823529412,
		g: 0.709803921568627,
		b: 0.0666666666666667
	},
	'p111': {
		name: '111',
		r: 0.666666666666667,
		g: 0.576470588235294,
		b: 0.0392156862745098
	},
	'p112': {
		name: '112',
		r: 0.6,
		g: 0.517647058823529,
		b: 0.0392156862745098
	},
	'p113': {
		name: '113',
		r: 0.976470588235294,
		g: 0.898039215686275,
		b: 0.356862745098039
	},
	'p114': {
		name: '114',
		r: 0.976470588235294,
		g: 0.886274509803922,
		b: 0.298039215686275
	},
	'p115': {
		name: '115',
		r: 0.976470588235294,
		g: 0.87843137254902,
		b: 0.298039215686275
	},
	'p116': {
		name: '116',
		r: 0.988235294117647,
		g: 0.819607843137255,
		b: 0.0862745098039216
	},
	'p116 2X': {
		name: '116 2X',
		r: 0.968627450980392,
		g: 0.709803921568627,
		b: 0.0470588235294118
	},
	'p117': {
		name: '117',
		r: 0.776470588235294,
		g: 0.627450980392157,
		b: 0.0470588235294118
	},
	'p118': {
		name: '118',
		r: 0.666666666666667,
		g: 0.556862745098039,
		b: 0.0392156862745098
	},
	'p119': {
		name: '119',
		r: 0.537254901960784,
		g: 0.466666666666667,
		b: 0.0980392156862745
	},
	'p120': {
		name: '120',
		r: 0.976470588235294,
		g: 0.886274509803922,
		b: 0.498039215686275
	},
	'p1205': {
		name: '1205',
		r: 0.968627450980392,
		g: 0.909803921568627,
		b: 0.666666666666667
	},
	'p121': {
		name: '121',
		r: 0.976470588235294,
		g: 0.87843137254902,
		b: 0.43921568627451
	},
	'p1215': {
		name: '1215',
		r: 0.976470588235294,
		g: 0.87843137254902,
		b: 0.549019607843137
	},
	'p122': {
		name: '122',
		r: 0.988235294117647,
		g: 0.847058823529412,
		b: 0.337254901960784
	},
	'p1225': {
		name: '1225',
		r: 1,
		g: 0.8,
		b: 0.286274509803922
	},
	'p123': {
		name: '123',
		r: 1,
		g: 0.776470588235294,
		b: 0.117647058823529
	},
	'p1235': {
		name: '1235',
		r: 0.988235294117647,
		g: 0.709803921568627,
		b: 0.0784313725490196
	},
	'p124': {
		name: '124',
		r: 0.87843137254902,
		g: 0.666666666666667,
		b: 0.0588235294117647
	},
	'p1245': {
		name: '1245',
		r: 0.749019607843137,
		g: 0.568627450980392,
		b: 0.0470588235294118
	},
	'p125': {
		name: '125',
		r: 0.709803921568627,
		g: 0.549019607843137,
		b: 0.0392156862745098
	},
	'p1255': {
		name: '1255',
		r: 0.63921568627451,
		g: 0.498039215686275,
		b: 0.0784313725490196
	},
	'p126': {
		name: '126',
		r: 0.63921568627451,
		g: 0.509803921568627,
		b: 0.0196078431372549
	},
	'p1265': {
		name: '1265',
		r: 0.486274509803922,
		g: 0.388235294117647,
		b: 0.0862745098039216
	},
	'p127': {
		name: '127',
		r: 0.956862745098039,
		g: 0.886274509803922,
		b: 0.529411764705882
	},
	'p128': {
		name: '128',
		r: 0.956862745098039,
		g: 0.858823529411765,
		b: 0.376470588235294
	},
	'p129': {
		name: '129',
		r: 0.949019607843137,
		g: 0.819607843137255,
		b: 0.23921568627451
	},
	'p130': {
		name: '130',
		r: 0.917647058823529,
		g: 0.686274509803922,
		b: 0.0588235294117647
	},
	'p130 2X': {
		name: '130 2X',
		r: 0.886274509803922,
		g: 0.568627450980392,
		b: 0
	},
	'p131': {
		name: '131',
		r: 0.776470588235294,
		g: 0.576470588235294,
		b: 0.0392156862745098
	},
	'p132': {
		name: '132',
		r: 0.619607843137255,
		g: 0.486274509803922,
		b: 0.0392156862745098
	},
	'p133': {
		name: '133',
		r: 0.43921568627451,
		g: 0.356862745098039,
		b: 0.0392156862745098
	},
	'p134': {
		name: '134',
		r: 1,
		g: 0.847058823529412,
		b: 0.498039215686275
	},
	'p1345': {
		name: '1345',
		r: 1,
		g: 0.83921568627451,
		b: 0.568627450980392
	},
	'p135': {
		name: '135',
		r: 0.988235294117647,
		g: 0.788235294117647,
		b: 0.388235294117647
	},
	'p1355': {
		name: '1355',
		r: 0.988235294117647,
		g: 0.807843137254902,
		b: 0.529411764705882
	},
	'p136': {
		name: '136',
		r: 0.988235294117647,
		g: 0.749019607843137,
		b: 0.286274509803922
	},
	'p1365': {
		name: '1365',
		r: 0.988235294117647,
		g: 0.729411764705882,
		b: 0.368627450980392
	},
	'p137': {
		name: '137',
		r: 0.988235294117647,
		g: 0.63921568627451,
		b: 0.0666666666666667
	},
	'p1375': {
		name: '1375',
		r: 0.976470588235294,
		g: 0.607843137254902,
		b: 0.0470588235294118
	},
	'p138': {
		name: '138',
		r: 0.847058823529412,
		g: 0.549019607843137,
		b: 0.00784313725490196
	},
	'p1385': {
		name: '1385',
		r: 0.8,
		g: 0.47843137254902,
		b: 0.00784313725490196
	},
	'p139': {
		name: '139',
		r: 0.686274509803922,
		g: 0.458823529411765,
		b: 0.0196078431372549
	},
	'p1395': {
		name: '1395',
		r: 0.6,
		g: 0.376470588235294,
		b: 0.0274509803921569
	},
	'p140': {
		name: '140',
		r: 0.47843137254902,
		g: 0.356862745098039,
		b: 0.0666666666666667
	},
	'p1405': {
		name: '1405',
		r: 0.419607843137255,
		g: 0.27843137254902,
		b: 0.0784313725490196
	},
	'p141': {
		name: '141',
		r: 0.949019607843137,
		g: 0.807843137254902,
		b: 0.407843137254902
	},
	'p142': {
		name: '142',
		r: 0.949019607843137,
		g: 0.749019607843137,
		b: 0.286274509803922
	},
	'p143': {
		name: '143',
		r: 0.937254901960784,
		g: 0.698039215686274,
		b: 0.176470588235294
	},
	'p144': {
		name: '144',
		r: 0.886274509803922,
		g: 0.549019607843137,
		b: 0.0196078431372549
	},
	'p145': {
		name: '145',
		r: 0.776470588235294,
		g: 0.498039215686275,
		b: 0.0274509803921569
	},
	'p146': {
		name: '146',
		r: 0.619607843137255,
		g: 0.419607843137255,
		b: 0.0196078431372549
	},
	'p147': {
		name: '147',
		r: 0.447058823529412,
		g: 0.368627450980392,
		b: 0.149019607843137
	},
	'p148': {
		name: '148',
		r: 1,
		g: 0.83921568627451,
		b: 0.607843137254902
	},
	'p1485': {
		name: '1485',
		r: 1,
		g: 0.717647058823529,
		b: 0.466666666666667
	},
	'p149': {
		name: '149',
		r: 0.988235294117647,
		g: 0.8,
		b: 0.576470588235294
	},
	'p1495': {
		name: '1495',
		r: 1,
		g: 0.6,
		b: 0.247058823529412
	},
	'p150': {
		name: '150',
		r: 0.988235294117647,
		g: 0.67843137254902,
		b: 0.337254901960784
	},
	'p1505': {
		name: '1505',
		r: 0.956862745098039,
		g: 0.486274509803922,
		b: 0
	},
	'p151': {
		name: '151',
		r: 0.968627450980392,
		g: 0.498039215686275,
		b: 0
	},
	'p152': {
		name: '152',
		r: 0.866666666666667,
		g: 0.458823529411765,
		b: 0
	},
	'p1525': {
		name: '1525',
		r: 0.709803921568627,
		g: 0.329411764705882,
		b: 0
	},
	'p153': {
		name: '153',
		r: 0.737254901960784,
		g: 0.427450980392157,
		b: 0.0392156862745098
	},
	'p1535': {
		name: '1535',
		r: 0.549019607843137,
		g: 0.266666666666667,
		b: 0
	},
	'p154': {
		name: '154',
		r: 0.6,
		g: 0.349019607843137,
		b: 0.0196078431372549
	},
	'p1545': {
		name: '1545',
		r: 0.27843137254902,
		g: 0.133333333333333,
		b: 0
	},
	'p155': {
		name: '155',
		r: 0.956862745098039,
		g: 0.858823529411765,
		b: 0.666666666666667
	},
	'p1555': {
		name: '1555',
		r: 0.976470588235294,
		g: 0.749019607843137,
		b: 0.619607843137255
	},
	'p156': {
		name: '156',
		r: 0.949019607843137,
		g: 0.776470588235294,
		b: 0.549019607843137
	},
	'p1565': {
		name: '1565',
		r: 0.988235294117647,
		g: 0.647058823529412,
		b: 0.466666666666667
	},
	'p157': {
		name: '157',
		r: 0.929411764705882,
		g: 0.627450980392157,
		b: 0.309803921568627
	},
	'p1575': {
		name: '1575',
		r: 0.988235294117647,
		g: 0.529411764705882,
		b: 0.266666666666667
	},
	'p158': {
		name: '158',
		r: 0.909803921568627,
		g: 0.458823529411765,
		b: 0.0666666666666667
	},
	'p1585': {
		name: '1585',
		r: 0.976470588235294,
		g: 0.419607843137255,
		b: 0.0274509803921569
	},
	'p159': {
		name: '159',
		r: 0.776470588235294,
		g: 0.376470588235294,
		b: 0.0196078431372549
	},
	'p1595': {
		name: '1595',
		r: 0.819607843137255,
		g: 0.356862745098039,
		b: 0.0196078431372549
	},
	'p160': {
		name: '160',
		r: 0.619607843137255,
		g: 0.329411764705882,
		b: 0.0392156862745098
	},
	'p1605': {
		name: '1605',
		r: 0.627450980392157,
		g: 0.309803921568627,
		b: 0.0666666666666667
	},
	'p161': {
		name: '161',
		r: 0.388235294117647,
		g: 0.227450980392157,
		b: 0.0666666666666667
	},
	'p1615': {
		name: '1615',
		r: 0.517647058823529,
		g: 0.247058823529412,
		b: 0.0588235294117647
	},
	'p162': {
		name: '162',
		r: 0.976470588235294,
		g: 0.776470588235294,
		b: 0.666666666666667
	},
	'p1625': {
		name: '1625',
		r: 0.976470588235294,
		g: 0.647058823529412,
		b: 0.549019607843137
	},
	'p163': {
		name: '163',
		r: 0.988235294117647,
		g: 0.619607843137255,
		b: 0.43921568627451
	},
	'p1635': {
		name: '1635',
		r: 0.976470588235294,
		g: 0.556862745098039,
		b: 0.427450980392157
	},
	'p164': {
		name: '164',
		r: 0.988235294117647,
		g: 0.498039215686275,
		b: 0.247058823529412
	},
	'p1645': {
		name: '1645',
		r: 0.976470588235294,
		g: 0.447058823529412,
		b: 0.258823529411765
	},
	'p165': {
		name: '165',
		r: 0.976470588235294,
		g: 0.388235294117647,
		b: 0.00784313725490196
	},
	'p165 2X': {
		name: '165 2X',
		r: 0.917647058823529,
		g: 0.309803921568627,
		b: 0
	},
	'p1655': {
		name: '1655',
		r: 0.976470588235294,
		g: 0.337254901960784,
		b: 0.00784313725490196
	},
	'p166': {
		name: '166',
		r: 0.866666666666667,
		g: 0.349019607843137,
		b: 0
	},
	'p1665': {
		name: '1665',
		r: 0.866666666666667,
		g: 0.309803921568627,
		b: 0.0196078431372549
	},
	'p167': {
		name: '167',
		r: 0.737254901960784,
		g: 0.309803921568627,
		b: 0.0274509803921569
	},
	'p1675': {
		name: '1675',
		r: 0.647058823529412,
		g: 0.247058823529412,
		b: 0.0588235294117647
	},
	'p168': {
		name: '168',
		r: 0.427450980392157,
		g: 0.188235294117647,
		b: 0.0666666666666667
	},
	'p1685': {
		name: '1685',
		r: 0.517647058823529,
		g: 0.207843137254902,
		b: 0.0666666666666667
	},
	'p169': {
		name: '169',
		r: 0.976470588235294,
		g: 0.729411764705882,
		b: 0.666666666666667
	},
	'p170': {
		name: '170',
		r: 0.976470588235294,
		g: 0.537254901960784,
		b: 0.447058823529412
	},
	'p171': {
		name: '171',
		r: 0.976470588235294,
		g: 0.376470588235294,
		b: 0.227450980392157
	},
	'p172': {
		name: '172',
		r: 0.968627450980392,
		g: 0.286274509803922,
		b: 0.00784313725490196
	},
	'p173': {
		name: '173',
		r: 0.819607843137255,
		g: 0.266666666666667,
		b: 0.0784313725490196
	},
	'p174': {
		name: '174',
		r: 0.576470588235294,
		g: 0.2,
		b: 0.0666666666666667
	},
	'p175': {
		name: '175',
		r: 0.427450980392157,
		g: 0.2,
		b: 0.129411764705882
	},
	'p176': {
		name: '176',
		r: 0.976470588235294,
		g: 0.686274509803922,
		b: 0.67843137254902
	},
	'p1765': {
		name: '1765',
		r: 0.976470588235294,
		g: 0.619607843137255,
		b: 0.63921568627451
	},
	'p1767': {
		name: '1767',
		r: 0.976470588235294,
		g: 0.698039215686274,
		b: 0.717647058823529
	},
	'p177': {
		name: '177',
		r: 0.976470588235294,
		g: 0.509803921568627,
		b: 0.498039215686275
	},
	'p1775': {
		name: '1775',
		r: 0.976470588235294,
		g: 0.517647058823529,
		b: 0.556862745098039
	},
	'p1777': {
		name: '1777',
		r: 0.988235294117647,
		g: 0.4,
		b: 0.458823529411765
	},
	'p178': {
		name: '178',
		r: 0.976470588235294,
		g: 0.368627450980392,
		b: 0.349019607843137
	},
	'p1785': {
		name: '1785',
		r: 0.988235294117647,
		g: 0.309803921568627,
		b: 0.349019607843137
	},
	'p1787': {
		name: '1787',
		r: 0.956862745098039,
		g: 0.247058823529412,
		b: 0.309803921568627
	},
	'p1788': {
		name: '1788',
		r: 0.937254901960784,
		g: 0.168627450980392,
		b: 0.176470588235294
	},
	'p1788 2X': {
		name: '1788 2X',
		r: 0.83921568627451,
		g: 0.129411764705882,
		b: 0
	},
	'p179': {
		name: '179',
		r: 0.886274509803922,
		g: 0.23921568627451,
		b: 0.156862745098039
	},
	'p1795': {
		name: '1795',
		r: 0.83921568627451,
		g: 0.156862745098039,
		b: 0.156862745098039
	},
	'p1797': {
		name: '1797',
		r: 0.8,
		g: 0.176470588235294,
		b: 0.188235294117647
	},
	'p180': {
		name: '180',
		r: 0.756862745098039,
		g: 0.219607843137255,
		b: 0.156862745098039
	},
	'p1805': {
		name: '1805',
		r: 0.686274509803922,
		g: 0.149019607843137,
		b: 0.149019607843137
	},
	'p1807': {
		name: '1807',
		r: 0.627450980392157,
		g: 0.188235294117647,
		b: 0.2
	},
	'p181': {
		name: '181',
		r: 0.486274509803922,
		g: 0.176470588235294,
		b: 0.137254901960784
	},
	'p1810': {
		name: '1810',
		r: 0.486274509803922,
		g: 0.129411764705882,
		b: 0.117647058823529
	},
	'p1817': {
		name: '1817',
		r: 0.356862745098039,
		g: 0.176470588235294,
		b: 0.156862745098039
	},
	'p182': {
		name: '182',
		r: 0.976470588235294,
		g: 0.749019607843137,
		b: 0.756862745098039
	},
	'p183': {
		name: '183',
		r: 0.988235294117647,
		g: 0.549019607843137,
		b: 0.6
	},
	'p184': {
		name: '184',
		r: 0.988235294117647,
		g: 0.368627450980392,
		b: 0.447058823529412
	},
	'p185': {
		name: '185',
		r: 0.909803921568627,
		g: 0.0666666666666667,
		b: 0.176470588235294
	},
	'p185 2X': {
		name: '185 2X',
		r: 0.819607843137255,
		g: 0.0862745098039216,
		b: 0
	},
	'p186': {
		name: '186',
		r: 0.807843137254902,
		g: 0.0666666666666667,
		b: 0.149019607843137
	},
	'p187': {
		name: '187',
		r: 0.686274509803922,
		g: 0.117647058823529,
		b: 0.176470588235294
	},
	'p188': {
		name: '188',
		r: 0.486274509803922,
		g: 0.129411764705882,
		b: 0.156862745098039
	},
	'p189': {
		name: '189',
		r: 1,
		g: 0.63921568627451,
		b: 0.698039215686274
	},
	'p1895': {
		name: '1895',
		r: 0.988235294117647,
		g: 0.749019607843137,
		b: 0.788235294117647
	},
	'p190': {
		name: '190',
		r: 0.988235294117647,
		g: 0.458823529411765,
		b: 0.556862745098039
	},
	'p1905': {
		name: '1905',
		r: 0.988235294117647,
		g: 0.607843137254902,
		b: 0.698039215686274
	},
	'p191': {
		name: '191',
		r: 0.956862745098039,
		g: 0.27843137254902,
		b: 0.419607843137255
	},
	'p1915': {
		name: '1915',
		r: 0.956862745098039,
		g: 0.329411764705882,
		b: 0.486274509803922
	},
	'p192': {
		name: '192',
		r: 0.898039215686275,
		g: 0.0196078431372549,
		b: 0.227450980392157
	},
	'p1925': {
		name: '1925',
		r: 0.87843137254902,
		g: 0.0274509803921569,
		b: 0.27843137254902
	},
	'p193': {
		name: '193',
		r: 0.768627450980392,
		g: 0,
		b: 0.262745098039216
	},
	'p1935': {
		name: '1935',
		r: 0.756862745098039,
		g: 0.0196078431372549,
		b: 0.219607843137255
	},
	'p194': {
		name: '194',
		r: 0.6,
		g: 0.129411764705882,
		b: 0.207843137254902
	},
	'p1945': {
		name: '1945',
		r: 0.658823529411765,
		g: 0.0470588235294118,
		b: 0.207843137254902
	},
	'p1955': {
		name: '1955',
		r: 0.576470588235294,
		g: 0.0862745098039216,
		b: 0.219607843137255
	},
	'p196': {
		name: '196',
		r: 0.980392156862745,
		g: 0.835294117647059,
		b: 0.882352941176471
	},
	'p197': {
		name: '197',
		r: 0.964705882352941,
		g: 0.647058823529412,
		b: 0.745098039215686
	},
	'p198': {
		name: '198',
		r: 0.937254901960784,
		g: 0.356862745098039,
		b: 0.517647058823529
	},
	'p199': {
		name: '199',
		r: 0.627450980392157,
		g: 0.152941176470588,
		b: 0.294117647058824
	},
	'p200': {
		name: '200',
		r: 0.768627450980392,
		g: 0.117647058823529,
		b: 0.227450980392157
	},
	'p201': {
		name: '201',
		r: 0.63921568627451,
		g: 0.149019607843137,
		b: 0.219607843137255
	},
	'p202': {
		name: '202',
		r: 0.549019607843137,
		g: 0.149019607843137,
		b: 0.2
	},
	'p203': {
		name: '203',
		r: 0.949019607843137,
		g: 0.686274509803922,
		b: 0.756862745098039
	},
	'p204': {
		name: '204',
		r: 0.929411764705882,
		g: 0.47843137254902,
		b: 0.619607843137255
	},
	'p205': {
		name: '205',
		r: 0.898039215686275,
		g: 0.298039215686275,
		b: 0.486274509803922
	},
	'p206': {
		name: '206',
		r: 0.827450980392157,
		g: 0.0196078431372549,
		b: 0.27843137254902
	},
	'p207': {
		name: '207',
		r: 0.752941176470588,
		g: 0,
		b: 0.305882352941176
	},
	'p208': {
		name: '208',
		r: 0.556862745098039,
		g: 0.137254901960784,
		b: 0.266666666666667
	},
	'p209': {
		name: '209',
		r: 0.458823529411765,
		g: 0.149019607843137,
		b: 0.23921568627451
	},
	'p210': {
		name: '210',
		r: 1,
		g: 0.627450980392157,
		b: 0.749019607843137
	},
	'p211': {
		name: '211',
		r: 1,
		g: 0.466666666666667,
		b: 0.658823529411765
	},
	'p212': {
		name: '212',
		r: 0.976470588235294,
		g: 0.309803921568627,
		b: 0.556862745098039
	},
	'p213': {
		name: '213',
		r: 0.917647058823529,
		g: 0.0588235294117647,
		b: 0.419607843137255
	},
	'p214': {
		name: '214',
		r: 0.8,
		g: 0.00784313725490196,
		b: 0.337254901960784
	},
	'p215': {
		name: '215',
		r: 0.647058823529412,
		g: 0.0196078431372549,
		b: 0.266666666666667
	},
	'p216': {
		name: '216',
		r: 0.486274509803922,
		g: 0.117647058823529,
		b: 0.247058823529412
	},
	'p217': {
		name: '217',
		r: 0.956862745098039,
		g: 0.749019607843137,
		b: 0.819607843137255
	},
	'p218': {
		name: '218',
		r: 0.929411764705882,
		g: 0.447058823529412,
		b: 0.666666666666667
	},
	'p219': {
		name: '219',
		r: 0.886274509803922,
		g: 0.156862745098039,
		b: 0.509803921568627
	},
	'p220': {
		name: '220',
		r: 0.666666666666667,
		g: 0,
		b: 0.309803921568627
	},
	'p221': {
		name: '221',
		r: 0.576470588235294,
		g: 0,
		b: 0.258823529411765
	},
	'p222': {
		name: '222',
		r: 0.43921568627451,
		g: 0.0980392156862745,
		b: 0.23921568627451
	},
	'p223': {
		name: '223',
		r: 0.976470588235294,
		g: 0.576470588235294,
		b: 0.768627450980392
	},
	'p224': {
		name: '224',
		r: 0.956862745098039,
		g: 0.419607843137255,
		b: 0.686274509803922
	},
	'p225': {
		name: '225',
		r: 0.929411764705882,
		g: 0.156862745098039,
		b: 0.576470588235294
	},
	'p226': {
		name: '226',
		r: 0.83921568627451,
		g: 0.00784313725490196,
		b: 0.43921568627451
	},
	'p227': {
		name: '227',
		r: 0.67843137254902,
		g: 0,
		b: 0.356862745098039
	},
	'p228': {
		name: '228',
		r: 0.549019607843137,
		g: 0,
		b: 0.298039215686275
	},
	'p229': {
		name: '229',
		r: 0.427450980392157,
		g: 0.129411764705882,
		b: 0.247058823529412
	},
	'p230': {
		name: '230',
		r: 1,
		g: 0.627450980392157,
		b: 0.8
	},
	'p231': {
		name: '231',
		r: 0.988235294117647,
		g: 0.43921568627451,
		b: 0.729411764705882
	},
	'p232': {
		name: '232',
		r: 0.956862745098039,
		g: 0.247058823529412,
		b: 0.647058823529412
	},
	'p233': {
		name: '233',
		r: 0.807843137254902,
		g: 0,
		b: 0.486274509803922
	},
	'p234': {
		name: '234',
		r: 0.666666666666667,
		g: 0,
		b: 0.4
	},
	'p235': {
		name: '235',
		r: 0.556862745098039,
		g: 0.0196078431372549,
		b: 0.329411764705882
	},
	'p236': {
		name: '236',
		r: 0.976470588235294,
		g: 0.686274509803922,
		b: 0.827450980392157
	},
	'p2365': {
		name: '2365',
		r: 0.968627450980392,
		g: 0.768627450980392,
		b: 0.847058823529412
	},
	'p237': {
		name: '237',
		r: 0.956862745098039,
		g: 0.517647058823529,
		b: 0.768627450980392
	},
	'p2375': {
		name: '2375',
		r: 0.917647058823529,
		g: 0.419607843137255,
		b: 0.749019607843137
	},
	'p238': {
		name: '238',
		r: 0.929411764705882,
		g: 0.309803921568627,
		b: 0.686274509803922
	},
	'p2385': {
		name: '2385',
		r: 0.858823529411765,
		g: 0.156862745098039,
		b: 0.647058823529412
	},
	'p239': {
		name: '239',
		r: 0.87843137254902,
		g: 0.129411764705882,
		b: 0.619607843137255
	},
	'p2395': {
		name: '2395',
		r: 0.768627450980392,
		g: 0,
		b: 0.549019607843137
	},
	'p240': {
		name: '240',
		r: 0.768627450980392,
		g: 0.0588235294117647,
		b: 0.537254901960784
	},
	'p2405': {
		name: '2405',
		r: 0.658823529411765,
		g: 0,
		b: 0.47843137254902
	},
	'p241': {
		name: '241',
		r: 0.67843137254902,
		g: 0,
		b: 0.458823529411765
	},
	'p2415': {
		name: '2415',
		r: 0.607843137254902,
		g: 0,
		b: 0.43921568627451
	},
	'p242': {
		name: '242',
		r: 0.486274509803922,
		g: 0.109803921568627,
		b: 0.317647058823529
	},
	'p2425': {
		name: '2425',
		r: 0.529411764705882,
		g: 0,
		b: 0.356862745098039
	},
	'p243': {
		name: '243',
		r: 0.949019607843137,
		g: 0.729411764705882,
		b: 0.847058823529412
	},
	'p244': {
		name: '244',
		r: 0.929411764705882,
		g: 0.627450980392157,
		b: 0.827450980392157
	},
	'p245': {
		name: '245',
		r: 0.909803921568627,
		g: 0.498039215686275,
		b: 0.788235294117647
	},
	'p246': {
		name: '246',
		r: 0.8,
		g: 0,
		b: 0.627450980392157
	},
	'p247': {
		name: '247',
		r: 0.717647058823529,
		g: 0,
		b: 0.556862745098039
	},
	'p248': {
		name: '248',
		r: 0.63921568627451,
		g: 0.0196078431372549,
		b: 0.498039215686275
	},
	'p249': {
		name: '249',
		r: 0.498039215686275,
		g: 0.156862745098039,
		b: 0.376470588235294
	},
	'p250': {
		name: '250',
		r: 0.929411764705882,
		g: 0.768627450980392,
		b: 0.866666666666667
	},
	'p251': {
		name: '251',
		r: 0.886274509803922,
		g: 0.619607843137255,
		b: 0.83921568627451
	},
	'p252': {
		name: '252',
		r: 0.827450980392157,
		g: 0.419607843137255,
		b: 0.776470588235294
	},
	'p253': {
		name: '253',
		r: 0.686274509803922,
		g: 0.137254901960784,
		b: 0.647058823529412
	},
	'p254': {
		name: '254',
		r: 0.627450980392157,
		g: 0.176470588235294,
		b: 0.588235294117647
	},
	'p255': {
		name: '255',
		r: 0.466666666666667,
		g: 0.176470588235294,
		b: 0.419607843137255
	},
	'p256': {
		name: '256',
		r: 0.898039215686275,
		g: 0.768627450980392,
		b: 0.83921568627451
	},
	'p2562': {
		name: '2562',
		r: 0.847058823529412,
		g: 0.658823529411765,
		b: 0.847058823529412
	},
	'p2563': {
		name: '2563',
		r: 0.819607843137255,
		g: 0.627450980392157,
		b: 0.8
	},
	'p2567': {
		name: '2567',
		r: 0.749019607843137,
		g: 0.576470588235294,
		b: 0.8
	},
	'p257': {
		name: '257',
		r: 0.827450980392157,
		g: 0.647058823529412,
		b: 0.788235294117647
	},
	'p2572': {
		name: '2572',
		r: 0.776470588235294,
		g: 0.529411764705882,
		b: 0.819607843137255
	},
	'p2573': {
		name: '2573',
		r: 0.729411764705882,
		g: 0.486274509803922,
		b: 0.737254901960784
	},
	'p2577': {
		name: '2577',
		r: 0.666666666666667,
		g: 0.447058823529412,
		b: 0.749019607843137
	},
	'p258': {
		name: '258',
		r: 0.607843137254902,
		g: 0.309803921568627,
		b: 0.588235294117647
	},
	'p2582': {
		name: '2582',
		r: 0.666666666666667,
		g: 0.27843137254902,
		b: 0.729411764705882
	},
	'p2583': {
		name: '2583',
		r: 0.619607843137255,
		g: 0.309803921568627,
		b: 0.647058823529412
	},
	'p2587': {
		name: '2587',
		r: 0.556862745098039,
		g: 0.27843137254902,
		b: 0.67843137254902
	},
	'p259': {
		name: '259',
		r: 0.447058823529412,
		g: 0.0862745098039216,
		b: 0.419607843137255
	},
	'p2592': {
		name: '2592',
		r: 0.576470588235294,
		g: 0.0588235294117647,
		b: 0.647058823529412
	},
	'p2593': {
		name: '2593',
		r: 0.529411764705882,
		g: 0.168627450980392,
		b: 0.576470588235294
	},
	'p2597': {
		name: '2597',
		r: 0.4,
		g: 0,
		b: 0.549019607843137
	},
	'p260': {
		name: '260',
		r: 0.407843137254902,
		g: 0.117647058823529,
		b: 0.356862745098039
	},
	'p2602': {
		name: '2602',
		r: 0.509803921568627,
		g: 0.0470588235294118,
		b: 0.556862745098039
	},
	'p2603': {
		name: '2603',
		r: 0.43921568627451,
		g: 0.0784313725490196,
		b: 0.47843137254902
	},
	'p2607': {
		name: '2607',
		r: 0.356862745098039,
		g: 0.00784313725490196,
		b: 0.47843137254902
	},
	'p261': {
		name: '261',
		r: 0.368627450980392,
		g: 0.129411764705882,
		b: 0.329411764705882
	},
	'p2612': {
		name: '2612',
		r: 0.43921568627451,
		g: 0.117647058823529,
		b: 0.447058823529412
	},
	'p2613': {
		name: '2613',
		r: 0.4,
		g: 0.0666666666666667,
		b: 0.427450980392157
	},
	'p2617': {
		name: '2617',
		r: 0.337254901960784,
		g: 0.0470588235294118,
		b: 0.43921568627451
	},
	'p262': {
		name: '262',
		r: 0.329411764705882,
		g: 0.137254901960784,
		b: 0.266666666666667
	},
	'p2622': {
		name: '2622',
		r: 0.376470588235294,
		g: 0.176470588235294,
		b: 0.349019607843137
	},
	'p2623': {
		name: '2623',
		r: 0.356862745098039,
		g: 0.0980392156862745,
		b: 0.368627450980392
	},
	'p2627': {
		name: '2627',
		r: 0.298039215686275,
		g: 0.0784313725490196,
		b: 0.368627450980392
	},
	'p263': {
		name: '263',
		r: 0.87843137254902,
		g: 0.807843137254902,
		b: 0.87843137254902
	},
	'p2635': {
		name: '2635',
		r: 0.788235294117647,
		g: 0.67843137254902,
		b: 0.847058823529412
	},
	'p264': {
		name: '264',
		r: 0.776470588235294,
		g: 0.666666666666667,
		b: 0.858823529411765
	},
	'p2645': {
		name: '2645',
		r: 0.709803921568627,
		g: 0.568627450980392,
		b: 0.819607843137255
	},
	'p265': {
		name: '265',
		r: 0.588235294117647,
		g: 0.388235294117647,
		b: 0.768627450980392
	},
	'p2655': {
		name: '2655',
		r: 0.607843137254902,
		g: 0.427450980392157,
		b: 0.776470588235294
	},
	'p266': {
		name: '266',
		r: 0.427450980392157,
		g: 0.156862745098039,
		b: 0.666666666666667
	},
	'p2665': {
		name: '2665',
		r: 0.537254901960784,
		g: 0.309803921568627,
		b: 0.749019607843137
	},
	'p267': {
		name: '267',
		r: 0.349019607843137,
		g: 0.0666666666666667,
		b: 0.556862745098039
	},
	'p268': {
		name: '268',
		r: 0.309803921568627,
		g: 0.129411764705882,
		b: 0.43921568627451
	},
	'p2685': {
		name: '2685',
		r: 0.337254901960784,
		g: 0,
		b: 0.549019607843137
	},
	'p269': {
		name: '269',
		r: 0.266666666666667,
		g: 0.137254901960784,
		b: 0.349019607843137
	},
	'p2695': {
		name: '2695',
		r: 0.266666666666667,
		g: 0.137254901960784,
		b: 0.368627450980392
	},
	'p270': {
		name: '270',
		r: 0.729411764705882,
		g: 0.686274509803922,
		b: 0.827450980392157
	},
	'p2705': {
		name: '2705',
		r: 0.67843137254902,
		g: 0.619607843137255,
		b: 0.827450980392157
	},
	'p2706': {
		name: '2706',
		r: 0.819607843137255,
		g: 0.807843137254902,
		b: 0.866666666666667
	},
	'p2707': {
		name: '2707',
		r: 0.749019607843137,
		g: 0.819607843137255,
		b: 0.898039215686275
	},
	'p2708': {
		name: '2708',
		r: 0.686274509803922,
		g: 0.737254901960784,
		b: 0.858823529411765
	},
	'p271': {
		name: '271',
		r: 0.619607843137255,
		g: 0.568627450980392,
		b: 0.776470588235294
	},
	'p2715': {
		name: '2715',
		r: 0.576470588235294,
		g: 0.47843137254902,
		b: 0.8
	},
	'p2716': {
		name: '2716',
		r: 0.647058823529412,
		g: 0.627450980392157,
		b: 0.83921568627451
	},
	'p2717': {
		name: '2717',
		r: 0.647058823529412,
		g: 0.729411764705882,
		b: 0.87843137254902
	},
	'p2718': {
		name: '2718',
		r: 0.356862745098039,
		g: 0.466666666666667,
		b: 0.8
	},
	'p272': {
		name: '272',
		r: 0.537254901960784,
		g: 0.466666666666667,
		b: 0.729411764705882
	},
	'p2725': {
		name: '2725',
		r: 0.447058823529412,
		g: 0.317647058823529,
		b: 0.737254901960784
	},
	'p2726': {
		name: '2726',
		r: 0.4,
		g: 0.337254901960784,
		b: 0.737254901960784
	},
	'p2727': {
		name: '2727',
		r: 0.368627450980392,
		g: 0.407843137254902,
		b: 0.768627450980392
	},
	'p2728': {
		name: '2728',
		r: 0.188235294117647,
		g: 0.266666666666667,
		b: 0.709803921568627
	},
	'p273': {
		name: '273',
		r: 0.219607843137255,
		g: 0.0980392156862745,
		b: 0.47843137254902
	},
	'p2735': {
		name: '2735',
		r: 0.309803921568627,
		g: 0,
		b: 0.576470588235294
	},
	'p2736': {
		name: '2736',
		r: 0.286274509803922,
		g: 0.188235294117647,
		b: 0.67843137254902
	},
	'p2738': {
		name: '2738',
		r: 0.176470588235294,
		g: 0,
		b: 0.556862745098039
	},
	'p274': {
		name: '274',
		r: 0.168627450980392,
		g: 0.0666666666666667,
		b: 0.4
	},
	'p2745': {
		name: '2745',
		r: 0.247058823529412,
		g: 0,
		b: 0.466666666666667
	},
	'p2746': {
		name: '2746',
		r: 0.247058823529412,
		g: 0.156862745098039,
		b: 0.576470588235294
	},
	'p2747': {
		name: '2747',
		r: 0.109803921568627,
		g: 0.0784313725490196,
		b: 0.419607843137255
	},
	'p2748': {
		name: '2748',
		r: 0.117647058823529,
		g: 0.109803921568627,
		b: 0.466666666666667
	},
	'p275': {
		name: '275',
		r: 0.149019607843137,
		g: 0.0588235294117647,
		b: 0.329411764705882
	},
	'p2755': {
		name: '2755',
		r: 0.207843137254902,
		g: 0,
		b: 0.427450980392157
	},
	'p2756': {
		name: '2756',
		r: 0.2,
		g: 0.156862745098039,
		b: 0.458823529411765
	},
	'p2757': {
		name: '2757',
		r: 0.0784313725490196,
		g: 0.0862745098039216,
		b: 0.329411764705882
	},
	'p2758': {
		name: '2758',
		r: 0.0980392156862745,
		g: 0.129411764705882,
		b: 0.407843137254902
	},
	'p276': {
		name: '276',
		r: 0.168627450980392,
		g: 0.129411764705882,
		b: 0.27843137254902
	},
	'p2765': {
		name: '2765',
		r: 0.168627450980392,
		g: 0.0470588235294118,
		b: 0.337254901960784
	},
	'p2766': {
		name: '2766',
		r: 0.168627450980392,
		g: 0.149019607843137,
		b: 0.356862745098039
	},
	'p2767': {
		name: '2767',
		r: 0.0784313725490196,
		g: 0.129411764705882,
		b: 0.23921568627451
	},
	'p2768': {
		name: '2768',
		r: 0.0666666666666667,
		g: 0.129411764705882,
		b: 0.317647058823529
	},
	'p277': {
		name: '277',
		r: 0.709803921568627,
		g: 0.819607843137255,
		b: 0.909803921568627
	},
	'p278': {
		name: '278',
		r: 0.6,
		g: 0.729411764705882,
		b: 0.866666666666667
	},
	'p279': {
		name: '279',
		r: 0.4,
		g: 0.537254901960784,
		b: 0.8
	},
	'p280': {
		name: '280',
		r: 0,
		g: 0.168627450980392,
		b: 0.498039215686275
	},
	'p281': {
		name: '281',
		r: 0,
		g: 0.156862745098039,
		b: 0.407843137254902
	},
	'p282': {
		name: '282',
		r: 0,
		g: 0.149019607843137,
		b: 0.329411764705882
	},
	'p283': {
		name: '283',
		r: 0.607843137254902,
		g: 0.768627450980392,
		b: 0.886274509803922
	},
	'p284': {
		name: '284',
		r: 0.458823529411765,
		g: 0.666666666666667,
		b: 0.858823529411765
	},
	'p285': {
		name: '285',
		r: 0.227450980392157,
		g: 0.458823529411765,
		b: 0.768627450980392
	},
	'p286': {
		name: '286',
		r: 0,
		g: 0.219607843137255,
		b: 0.658823529411765
	},
	'p287': {
		name: '287',
		r: 0,
		g: 0.219607843137255,
		b: 0.576470588235294
	},
	'p288': {
		name: '288',
		r: 0,
		g: 0.2,
		b: 0.498039215686275
	},
	'p289': {
		name: '289',
		r: 0,
		g: 0.149019607843137,
		b: 0.286274509803922
	},
	'p290': {
		name: '290',
		r: 0.768627450980392,
		g: 0.847058823529412,
		b: 0.886274509803922
	},
	'p2905': {
		name: '2905',
		r: 0.576470588235294,
		g: 0.776470588235294,
		b: 0.87843137254902
	},
	'p291': {
		name: '291',
		r: 0.658823529411765,
		g: 0.807843137254902,
		b: 0.886274509803922
	},
	'p2915': {
		name: '2915',
		r: 0.376470588235294,
		g: 0.686274509803922,
		b: 0.866666666666667
	},
	'p292': {
		name: '292',
		r: 0.458823529411765,
		g: 0.698039215686274,
		b: 0.866666666666667
	},
	'p2925': {
		name: '2925',
		r: 0,
		g: 0.556862745098039,
		b: 0.83921568627451
	},
	'p293': {
		name: '293',
		r: 0,
		g: 0.317647058823529,
		b: 0.729411764705882
	},
	'p2935': {
		name: '2935',
		r: 0,
		g: 0.356862745098039,
		b: 0.749019607843137
	},
	'p294': {
		name: '294',
		r: 0,
		g: 0.247058823529412,
		b: 0.529411764705882
	},
	'p2945': {
		name: '2945',
		r: 0,
		g: 0.329411764705882,
		b: 0.627450980392157
	},
	'p295': {
		name: '295',
		r: 0,
		g: 0.219607843137255,
		b: 0.419607843137255
	},
	'p2955': {
		name: '2955',
		r: 0,
		g: 0.23921568627451,
		b: 0.419607843137255
	},
	'p296': {
		name: '296',
		r: 0,
		g: 0.176470588235294,
		b: 0.27843137254902
	},
	'p2965': {
		name: '2965',
		r: 0,
		g: 0.2,
		b: 0.298039215686275
	},
	'p297': {
		name: '297',
		r: 0.509803921568627,
		g: 0.776470588235294,
		b: 0.886274509803922
	},
	'p2975': {
		name: '2975',
		r: 0.729411764705882,
		g: 0.87843137254902,
		b: 0.886274509803922
	},
	'p298': {
		name: '298',
		r: 0.317647058823529,
		g: 0.709803921568627,
		b: 0.87843137254902
	},
	'p2985': {
		name: '2985',
		r: 0.317647058823529,
		g: 0.749019607843137,
		b: 0.886274509803922
	},
	'p299': {
		name: '299',
		r: 0,
		g: 0.63921568627451,
		b: 0.866666666666667
	},
	'p2995': {
		name: '2995',
		r: 0,
		g: 0.647058823529412,
		b: 0.858823529411765
	},
	'p300': {
		name: '300',
		r: 0,
		g: 0.447058823529412,
		b: 0.776470588235294
	},
	'p3005': {
		name: '3005',
		r: 0,
		g: 0.517647058823529,
		b: 0.788235294117647
	},
	'p301': {
		name: '301',
		r: 0,
		g: 0.356862745098039,
		b: 0.6
	},
	'p3015': {
		name: '3015',
		r: 0,
		g: 0.43921568627451,
		b: 0.619607843137255
	},
	'p302': {
		name: '302',
		r: 0,
		g: 0.309803921568627,
		b: 0.427450980392157
	},
	'p3025': {
		name: '3025',
		r: 0,
		g: 0.329411764705882,
		b: 0.419607843137255
	},
	'p303': {
		name: '303',
		r: 0,
		g: 0.247058823529412,
		b: 0.329411764705882
	},
	'p3035': {
		name: '3035',
		r: 0,
		g: 0.266666666666667,
		b: 0.329411764705882
	},
	'p304': {
		name: '304',
		r: 0.647058823529412,
		g: 0.866666666666667,
		b: 0.886274509803922
	},
	'p305': {
		name: '305',
		r: 0.43921568627451,
		g: 0.807843137254902,
		b: 0.886274509803922
	},
	'p306': {
		name: '306',
		r: 0,
		g: 0.737254901960784,
		b: 0.886274509803922
	},
	'p306 2X': {
		name: '306 2X',
		r: 0,
		g: 0.63921568627451,
		b: 0.819607843137255
	},
	'p307': {
		name: '307',
		r: 0,
		g: 0.47843137254902,
		b: 0.647058823529412
	},
	'p308': {
		name: '308',
		r: 0,
		g: 0.376470588235294,
		b: 0.486274509803922
	},
	'p309': {
		name: '309',
		r: 0,
		g: 0.247058823529412,
		b: 0.286274509803922
	},
	'p310': {
		name: '310',
		r: 0.447058823529412,
		g: 0.819607843137255,
		b: 0.866666666666667
	},
	'p3105': {
		name: '3105',
		r: 0.498039215686275,
		g: 0.83921568627451,
		b: 0.858823529411765
	},
	'p311': {
		name: '311',
		r: 0.156862745098039,
		g: 0.768627450980392,
		b: 0.847058823529412
	},
	'p3115': {
		name: '3115',
		r: 0.176470588235294,
		g: 0.776470588235294,
		b: 0.83921568627451
	},
	'p312': {
		name: '312',
		r: 0,
		g: 0.67843137254902,
		b: 0.776470588235294
	},
	'p3125': {
		name: '3125',
		r: 0,
		g: 0.717647058823529,
		b: 0.776470588235294
	},
	'p313': {
		name: '313',
		r: 0,
		g: 0.6,
		b: 0.709803921568627
	},
	'p3135': {
		name: '3135',
		r: 0,
		g: 0.607843137254902,
		b: 0.666666666666667
	},
	'p314': {
		name: '314',
		r: 0,
		g: 0.509803921568627,
		b: 0.607843137254902
	},
	'p3145': {
		name: '3145',
		r: 0,
		g: 0.517647058823529,
		b: 0.556862745098039
	},
	'p315': {
		name: '315',
		r: 0,
		g: 0.419607843137255,
		b: 0.466666666666667
	},
	'p3155': {
		name: '3155',
		r: 0,
		g: 0.427450980392157,
		b: 0.458823529411765
	},
	'p316': {
		name: '316',
		r: 0,
		g: 0.286274509803922,
		b: 0.309803921568627
	},
	'p3165': {
		name: '3165',
		r: 0,
		g: 0.337254901960784,
		b: 0.356862745098039
	},
	'p317': {
		name: '317',
		r: 0.788235294117647,
		g: 0.909803921568627,
		b: 0.866666666666667
	},
	'p318': {
		name: '318',
		r: 0.576470588235294,
		g: 0.866666666666667,
		b: 0.858823529411765
	},
	'p319': {
		name: '319',
		r: 0.298039215686275,
		g: 0.807843137254902,
		b: 0.819607843137255
	},
	'p320': {
		name: '320',
		r: 0,
		g: 0.619607843137255,
		b: 0.627450980392157
	},
	'p320 2X': {
		name: '320 2X',
		r: 0,
		g: 0.498039215686275,
		b: 0.509803921568627
	},
	'p321': {
		name: '321',
		r: 0,
		g: 0.529411764705882,
		b: 0.537254901960784
	},
	'p322': {
		name: '322',
		r: 0,
		g: 0.447058823529412,
		b: 0.447058823529412
	},
	'p323': {
		name: '323',
		r: 0,
		g: 0.4,
		b: 0.388235294117647
	},
	'p324': {
		name: '324',
		r: 0.666666666666667,
		g: 0.866666666666667,
		b: 0.83921568627451
	},
	'p3242': {
		name: '3242',
		r: 0.529411764705882,
		g: 0.866666666666667,
		b: 0.819607843137255
	},
	'p3245': {
		name: '3245',
		r: 0.549019607843137,
		g: 0.87843137254902,
		b: 0.819607843137255
	},
	'p3248': {
		name: '3248',
		r: 0.47843137254902,
		g: 0.827450980392157,
		b: 0.756862745098039
	},
	'p325': {
		name: '325',
		r: 0.337254901960784,
		g: 0.788235294117647,
		b: 0.756862745098039
	},
	'p3252': {
		name: '3252',
		r: 0.337254901960784,
		g: 0.83921568627451,
		b: 0.788235294117647
	},
	'p3255': {
		name: '3255',
		r: 0.27843137254902,
		g: 0.83921568627451,
		b: 0.756862745098039
	},
	'p3258': {
		name: '3258',
		r: 0.207843137254902,
		g: 0.768627450980392,
		b: 0.686274509803922
	},
	'p326': {
		name: '326',
		r: 0,
		g: 0.698039215686274,
		b: 0.666666666666667
	},
	'p3262': {
		name: '3262',
		r: 0,
		g: 0.756862745098039,
		b: 0.709803921568627
	},
	'p3265': {
		name: '3265',
		r: 0,
		g: 0.776470588235294,
		b: 0.698039215686274
	},
	'p3268': {
		name: '3268',
		r: 0,
		g: 0.686274509803922,
		b: 0.6
	},
	'p327': {
		name: '327',
		r: 0,
		g: 0.549019607843137,
		b: 0.509803921568627
	},
	'p327 2X': {
		name: '327 2X',
		r: 0,
		g: 0.537254901960784,
		b: 0.466666666666667
	},
	'p3272': {
		name: '3272',
		r: 0,
		g: 0.666666666666667,
		b: 0.619607843137255
	},
	'p3275': {
		name: '3275',
		r: 0,
		g: 0.698039215686274,
		b: 0.627450980392157
	},
	'p3278': {
		name: '3278',
		r: 0,
		g: 0.607843137254902,
		b: 0.517647058823529
	},
	'p328': {
		name: '328',
		r: 0,
		g: 0.466666666666667,
		b: 0.43921568627451
	},
	'p3282': {
		name: '3282',
		r: 0,
		g: 0.549019607843137,
		b: 0.509803921568627
	},
	'p3285': {
		name: '3285',
		r: 0,
		g: 0.6,
		b: 0.529411764705882
	},
	'p3288': {
		name: '3288',
		r: 0,
		g: 0.509803921568627,
		b: 0.43921568627451
	},
	'p329': {
		name: '329',
		r: 0,
		g: 0.427450980392157,
		b: 0.4
	},
	'p3292': {
		name: '3292',
		r: 0,
		g: 0.376470588235294,
		b: 0.337254901960784
	},
	'p3295': {
		name: '3295',
		r: 0,
		g: 0.509803921568627,
		b: 0.447058823529412
	},
	'p3298': {
		name: '3298',
		r: 0,
		g: 0.419607843137255,
		b: 0.356862745098039
	},
	'p330': {
		name: '330',
		r: 0,
		g: 0.349019607843137,
		b: 0.317647058823529
	},
	'p3302': {
		name: '3302',
		r: 0,
		g: 0.286274509803922,
		b: 0.247058823529412
	},
	'p3305': {
		name: '3305',
		r: 0,
		g: 0.309803921568627,
		b: 0.258823529411765
	},
	'p3308': {
		name: '3308',
		r: 0,
		g: 0.266666666666667,
		b: 0.219607843137255
	},
	'p331': {
		name: '331',
		r: 0.729411764705882,
		g: 0.917647058823529,
		b: 0.83921568627451
	},
	'p332': {
		name: '332',
		r: 0.627450980392157,
		g: 0.898039215686275,
		b: 0.807843137254902
	},
	'p333': {
		name: '333',
		r: 0.368627450980392,
		g: 0.866666666666667,
		b: 0.756862745098039
	},
	'p334': {
		name: '334',
		r: 0,
		g: 0.6,
		b: 0.486274509803922
	},
	'p335': {
		name: '335',
		r: 0,
		g: 0.486274509803922,
		b: 0.4
	},
	'p336': {
		name: '336',
		r: 0,
		g: 0.407843137254902,
		b: 0.329411764705882
	},
	'p337': {
		name: '337',
		r: 0.607843137254902,
		g: 0.858823529411765,
		b: 0.756862745098039
	},
	'p3375': {
		name: '3375',
		r: 0.556862745098039,
		g: 0.886274509803922,
		b: 0.737254901960784
	},
	'p338': {
		name: '338',
		r: 0.47843137254902,
		g: 0.819607843137255,
		b: 0.709803921568627
	},
	'p3385': {
		name: '3385',
		r: 0.329411764705882,
		g: 0.847058823529412,
		b: 0.658823529411765
	},
	'p339': {
		name: '339',
		r: 0,
		g: 0.698039215686274,
		b: 0.549019607843137
	},
	'p3395': {
		name: '3395',
		r: 0,
		g: 0.788235294117647,
		b: 0.576470588235294
	},
	'p340': {
		name: '340',
		r: 0,
		g: 0.6,
		b: 0.466666666666667
	},
	'p3405': {
		name: '3405',
		r: 0,
		g: 0.698039215686274,
		b: 0.47843137254902
	},
	'p341': {
		name: '341',
		r: 0,
		g: 0.47843137254902,
		b: 0.368627450980392
	},
	'p3415': {
		name: '3415',
		r: 0,
		g: 0.486274509803922,
		b: 0.349019607843137
	},
	'p342': {
		name: '342',
		r: 0,
		g: 0.419607843137255,
		b: 0.329411764705882
	},
	'p3425': {
		name: '3425',
		r: 0,
		g: 0.407843137254902,
		b: 0.27843137254902
	},
	'p343': {
		name: '343',
		r: 0,
		g: 0.337254901960784,
		b: 0.247058823529412
	},
	'p3435': {
		name: '3435',
		r: 0.00784313725490196,
		g: 0.286274509803922,
		b: 0.188235294117647
	},
	'p344': {
		name: '344',
		r: 0.709803921568627,
		g: 0.886274509803922,
		b: 0.749019607843137
	},
	'p345': {
		name: '345',
		r: 0.588235294117647,
		g: 0.847058823529412,
		b: 0.686274509803922
	},
	'p346': {
		name: '346',
		r: 0.43921568627451,
		g: 0.807843137254902,
		b: 0.607843137254902
	},
	'p347': {
		name: '347',
		r: 0,
		g: 0.619607843137255,
		b: 0.376470588235294
	},
	'p348': {
		name: '348',
		r: 0,
		g: 0.529411764705882,
		b: 0.317647058823529
	},
	'p349': {
		name: '349',
		r: 0,
		g: 0.419607843137255,
		b: 0.247058823529412
	},
	'p350': {
		name: '350',
		r: 0.137254901960784,
		g: 0.309803921568627,
		b: 0.2
	},
	'p351': {
		name: '351',
		r: 0.709803921568627,
		g: 0.909803921568627,
		b: 0.749019607843137
	},
	'p352': {
		name: '352',
		r: 0.6,
		g: 0.898039215686275,
		b: 0.698039215686274
	},
	'p353': {
		name: '353',
		r: 0.517647058823529,
		g: 0.886274509803922,
		b: 0.658823529411765
	},
	'p354': {
		name: '354',
		r: 0,
		g: 0.717647058823529,
		b: 0.376470588235294
	},
	'p355': {
		name: '355',
		r: 0,
		g: 0.619607843137255,
		b: 0.286274509803922
	},
	'p356': {
		name: '356',
		r: 0,
		g: 0.47843137254902,
		b: 0.23921568627451
	},
	'p357': {
		name: '357',
		r: 0.129411764705882,
		g: 0.356862745098039,
		b: 0.2
	},
	'p358': {
		name: '358',
		r: 0.666666666666667,
		g: 0.866666666666667,
		b: 0.588235294117647
	},
	'p359': {
		name: '359',
		r: 0.627450980392157,
		g: 0.858823529411765,
		b: 0.556862745098039
	},
	'p360': {
		name: '360',
		r: 0.376470588235294,
		g: 0.776470588235294,
		b: 0.349019607843137
	},
	'p361': {
		name: '361',
		r: 0.117647058823529,
		g: 0.709803921568627,
		b: 0.227450980392157
	},
	'p362': {
		name: '362',
		r: 0.2,
		g: 0.619607843137255,
		b: 0.207843137254902
	},
	'p363': {
		name: '363',
		r: 0.23921568627451,
		g: 0.556862745098039,
		b: 0.2
	},
	'p364': {
		name: '364',
		r: 0.227450980392157,
		g: 0.466666666666667,
		b: 0.156862745098039
	},
	'p365': {
		name: '365',
		r: 0.827450980392157,
		g: 0.909803921568627,
		b: 0.63921568627451
	},
	'p366': {
		name: '366',
		r: 0.768627450980392,
		g: 0.898039215686275,
		b: 0.556862745098039
	},
	'p367': {
		name: '367',
		r: 0.666666666666667,
		g: 0.866666666666667,
		b: 0.427450980392157
	},
	'p368': {
		name: '368',
		r: 0.356862745098039,
		g: 0.749019607843137,
		b: 0.129411764705882
	},
	'p368 2X': {
		name: '368 2X',
		r: 0,
		g: 0.619607843137255,
		b: 0.0588235294117647
	},
	'p369': {
		name: '369',
		r: 0.337254901960784,
		g: 0.666666666666667,
		b: 0.109803921568627
	},
	'p370': {
		name: '370',
		r: 0.337254901960784,
		g: 0.556862745098039,
		b: 0.0784313725490196
	},
	'p371': {
		name: '371',
		r: 0.337254901960784,
		g: 0.419607843137255,
		b: 0.129411764705882
	},
	'p372': {
		name: '372',
		r: 0.847058823529412,
		g: 0.929411764705882,
		b: 0.588235294117647
	},
	'p373': {
		name: '373',
		r: 0.807843137254902,
		g: 0.917647058823529,
		b: 0.509803921568627
	},
	'p374': {
		name: '374',
		r: 0.729411764705882,
		g: 0.909803921568627,
		b: 0.376470588235294
	},
	'p375': {
		name: '375',
		r: 0.549019607843137,
		g: 0.83921568627451,
		b: 0
	},
	'p375 2X': {
		name: '375 2X',
		r: 0.329411764705882,
		g: 0.737254901960784,
		b: 0
	},
	'p376': {
		name: '376',
		r: 0.498039215686275,
		g: 0.729411764705882,
		b: 0
	},
	'p377': {
		name: '377',
		r: 0.43921568627451,
		g: 0.576470588235294,
		b: 0.00784313725490196
	},
	'p378': {
		name: '378',
		r: 0.337254901960784,
		g: 0.388235294117647,
		b: 0.0784313725490196
	},
	'p379': {
		name: '379',
		r: 0.87843137254902,
		g: 0.917647058823529,
		b: 0.407843137254902
	},
	'p380': {
		name: '380',
		r: 0.83921568627451,
		g: 0.898039215686275,
		b: 0.258823529411765
	},
	'p381': {
		name: '381',
		r: 0.8,
		g: 0.886274509803922,
		b: 0.149019607843137
	},
	'p382': {
		name: '382',
		r: 0.729411764705882,
		g: 0.847058823529412,
		b: 0.0392156862745098
	},
	'p382 2X': {
		name: '382 2X',
		r: 0.619607843137255,
		g: 0.768627450980392,
		b: 0
	},
	'p383': {
		name: '383',
		r: 0.63921568627451,
		g: 0.686274509803922,
		b: 0.0274509803921569
	},
	'p384': {
		name: '384',
		r: 0.576470588235294,
		g: 0.6,
		b: 0.0196078431372549
	},
	'p385': {
		name: '385',
		r: 0.43921568627451,
		g: 0.43921568627451,
		b: 0.0784313725490196
	},
	'p386': {
		name: '386',
		r: 0.909803921568627,
		g: 0.929411764705882,
		b: 0.376470588235294
	},
	'p387': {
		name: '387',
		r: 0.87843137254902,
		g: 0.929411764705882,
		b: 0.266666666666667
	},
	'p388': {
		name: '388',
		r: 0.83921568627451,
		g: 0.909803921568627,
		b: 0.0588235294117647
	},
	'p389': {
		name: '389',
		r: 0.807843137254902,
		g: 0.87843137254902,
		b: 0.0274509803921569
	},
	'p390': {
		name: '390',
		r: 0.729411764705882,
		g: 0.768627450980392,
		b: 0.0196078431372549
	},
	'p391': {
		name: '391',
		r: 0.619607843137255,
		g: 0.619607843137255,
		b: 0.0274509803921569
	},
	'p392': {
		name: '392',
		r: 0.517647058823529,
		g: 0.509803921568627,
		b: 0.0196078431372549
	},
	'p393': {
		name: '393',
		r: 0.949019607843137,
		g: 0.937254901960784,
		b: 0.529411764705882
	},
	'p3935': {
		name: '3935',
		r: 0.949019607843137,
		g: 0.929411764705882,
		b: 0.427450980392157
	},
	'p394': {
		name: '394',
		r: 0.917647058823529,
		g: 0.929411764705882,
		b: 0.207843137254902
	},
	'p3945': {
		name: '3945',
		r: 0.937254901960784,
		g: 0.917647058823529,
		b: 0.0274509803921569
	},
	'p395': {
		name: '395',
		r: 0.898039215686275,
		g: 0.909803921568627,
		b: 0.0666666666666667
	},
	'p3955': {
		name: '3955',
		r: 0.929411764705882,
		g: 0.886274509803922,
		b: 0.0666666666666667
	},
	'p396': {
		name: '396',
		r: 0.87843137254902,
		g: 0.886274509803922,
		b: 0.0470588235294118
	},
	'p3965': {
		name: '3965',
		r: 0.909803921568627,
		g: 0.866666666666667,
		b: 0.0666666666666667
	},
	'p397': {
		name: '397',
		r: 0.756862745098039,
		g: 0.749019607843137,
		b: 0.0392156862745098
	},
	'p3975': {
		name: '3975',
		r: 0.709803921568627,
		g: 0.658823529411765,
		b: 0.0470588235294118
	},
	'p398': {
		name: '398',
		r: 0.686274509803922,
		g: 0.658823529411765,
		b: 0.0392156862745098
	},
	'p3985': {
		name: '3985',
		r: 0.6,
		g: 0.549019607843137,
		b: 0.0392156862745098
	},
	'p399': {
		name: '399',
		r: 0.6,
		g: 0.556862745098039,
		b: 0.0274509803921569
	},
	'p3995': {
		name: '3995',
		r: 0.427450980392157,
		g: 0.376470588235294,
		b: 0.00784313725490196
	},
	'p400': {
		name: '400',
		r: 0.819607843137255,
		g: 0.776470588235294,
		b: 0.709803921568627
	},
	'p401': {
		name: '401',
		r: 0.756862745098039,
		g: 0.709803921568627,
		b: 0.647058823529412
	},
	'p402': {
		name: '402',
		r: 0.686274509803922,
		g: 0.647058823529412,
		b: 0.576470588235294
	},
	'p403': {
		name: '403',
		r: 0.6,
		g: 0.549019607843137,
		b: 0.486274509803922
	},
	'p404': {
		name: '404',
		r: 0.509803921568627,
		g: 0.458823529411765,
		b: 0.4
	},
	'p405': {
		name: '405',
		r: 0.419607843137255,
		g: 0.368627450980392,
		b: 0.309803921568627
	},
	'p406': {
		name: '406',
		r: 0.807843137254902,
		g: 0.756862745098039,
		b: 0.709803921568627
	},
	'p408': {
		name: '408',
		r: 0.658823529411765,
		g: 0.6,
		b: 0.549019607843137
	},
	'p409': {
		name: '409',
		r: 0.6,
		g: 0.537254901960784,
		b: 0.486274509803922
	},
	'p410': {
		name: '410',
		r: 0.486274509803922,
		g: 0.427450980392157,
		b: 0.388235294117647
	},
	'p411': {
		name: '411',
		r: 0.4,
		g: 0.349019607843137,
		b: 0.298039215686275
	},
	'p412': {
		name: '412',
		r: 0.23921568627451,
		g: 0.188235294117647,
		b: 0.156862745098039
	},
	'p413': {
		name: '413',
		r: 0.776470588235294,
		g: 0.756862745098039,
		b: 0.698039215686274
	},
	'p414': {
		name: '414',
		r: 0.709803921568627,
		g: 0.686274509803922,
		b: 0.627450980392157
	},
	'p415': {
		name: '415',
		r: 0.63921568627451,
		g: 0.619607843137255,
		b: 0.549019607843137
	},
	'p416': {
		name: '416',
		r: 0.556862745098039,
		g: 0.549019607843137,
		b: 0.47843137254902
	},
	'p417': {
		name: '417',
		r: 0.466666666666667,
		g: 0.447058823529412,
		b: 0.388235294117647
	},
	'p418': {
		name: '418',
		r: 0.376470588235294,
		g: 0.368627450980392,
		b: 0.309803921568627
	},
	'p419': {
		name: '419',
		r: 0.156862745098039,
		g: 0.156862745098039,
		b: 0.129411764705882
	},
	'p420': {
		name: '420',
		r: 0.819607843137255,
		g: 0.8,
		b: 0.749019607843137
	},
	'p421': {
		name: '421',
		r: 0.749019607843137,
		g: 0.729411764705882,
		b: 0.686274509803922
	},
	'p422': {
		name: '422',
		r: 0.686274509803922,
		g: 0.666666666666667,
		b: 0.63921568627451
	},
	'p423': {
		name: '423',
		r: 0.588235294117647,
		g: 0.576470588235294,
		b: 0.556862745098039
	},
	'p424': {
		name: '424',
		r: 0.509803921568627,
		g: 0.498039215686275,
		b: 0.466666666666667
	},
	'p425': {
		name: '425',
		r: 0.376470588235294,
		g: 0.376470588235294,
		b: 0.356862745098039
	},
	'p426': {
		name: '426',
		r: 0.168627450980392,
		g: 0.168627450980392,
		b: 0.156862745098039
	},
	'p427': {
		name: '427',
		r: 0.866666666666667,
		g: 0.858823529411765,
		b: 0.819607843137255
	},
	'p428': {
		name: '428',
		r: 0.819607843137255,
		g: 0.807843137254902,
		b: 0.776470588235294
	},
	'p429': {
		name: '429',
		r: 0.67843137254902,
		g: 0.686274509803922,
		b: 0.666666666666667
	},
	'p430': {
		name: '430',
		r: 0.568627450980392,
		g: 0.588235294117647,
		b: 0.576470588235294
	},
	'p431': {
		name: '431',
		r: 0.4,
		g: 0.427450980392157,
		b: 0.43921568627451
	},
	'p432': {
		name: '432',
		r: 0.266666666666667,
		g: 0.309803921568627,
		b: 0.317647058823529
	},
	'p433': {
		name: '433',
		r: 0.188235294117647,
		g: 0.219607843137255,
		b: 0.227450980392157
	},
	'p433 2X': {
		name: '433 2X',
		r: 0.0392156862745098,
		g: 0.0470588235294118,
		b: 0.0666666666666667
	},
	'p434': {
		name: '434',
		r: 0.87843137254902,
		g: 0.819607843137255,
		b: 0.776470588235294
	},
	'p435': {
		name: '435',
		r: 0.827450980392157,
		g: 0.749019607843137,
		b: 0.717647058823529
	},
	'p436': {
		name: '436',
		r: 0.737254901960784,
		g: 0.647058823529412,
		b: 0.619607843137255
	},
	'p437': {
		name: '437',
		r: 0.549019607843137,
		g: 0.43921568627451,
		b: 0.419607843137255
	},
	'p438': {
		name: '438',
		r: 0.349019607843137,
		g: 0.247058823529412,
		b: 0.23921568627451
	},
	'p439': {
		name: '439',
		r: 0.286274509803922,
		g: 0.207843137254902,
		b: 0.2
	},
	'p440': {
		name: '440',
		r: 0.247058823529412,
		g: 0.188235294117647,
		b: 0.168627450980392
	},
	'p441': {
		name: '441',
		r: 0.819607843137255,
		g: 0.819607843137255,
		b: 0.776470588235294
	},
	'p442': {
		name: '442',
		r: 0.729411764705882,
		g: 0.749019607843137,
		b: 0.717647058823529
	},
	'p443': {
		name: '443',
		r: 0.63921568627451,
		g: 0.658823529411765,
		b: 0.63921568627451
	},
	'p444': {
		name: '444',
		r: 0.537254901960784,
		g: 0.556862745098039,
		b: 0.549019607843137
	},
	'p445': {
		name: '445',
		r: 0.337254901960784,
		g: 0.349019607843137,
		b: 0.349019607843137
	},
	'p446': {
		name: '446',
		r: 0.286274509803922,
		g: 0.298039215686275,
		b: 0.286274509803922
	},
	'p447': {
		name: '447',
		r: 0.247058823529412,
		g: 0.247058823529412,
		b: 0.219607843137255
	},
	'p448': {
		name: '448',
		r: 0.329411764705882,
		g: 0.27843137254902,
		b: 0.176470588235294
	},
	'p4485': {
		name: '4485',
		r: 0.376470588235294,
		g: 0.298039215686275,
		b: 0.0666666666666667
	},
	'p449': {
		name: '449',
		r: 0.329411764705882,
		g: 0.27843137254902,
		b: 0.149019607843137
	},
	'p4495': {
		name: '4495',
		r: 0.529411764705882,
		g: 0.458823529411765,
		b: 0.188235294117647
	},
	'p450': {
		name: '450',
		r: 0.376470588235294,
		g: 0.329411764705882,
		b: 0.168627450980392
	},
	'p4505': {
		name: '4505',
		r: 0.627450980392157,
		g: 0.568627450980392,
		b: 0.317647058823529
	},
	'p451': {
		name: '451',
		r: 0.67843137254902,
		g: 0.627450980392157,
		b: 0.47843137254902
	},
	'p4515': {
		name: '4515',
		r: 0.737254901960784,
		g: 0.67843137254902,
		b: 0.458823529411765
	},
	'p452': {
		name: '452',
		r: 0.768627450980392,
		g: 0.717647058823529,
		b: 0.588235294117647
	},
	'p4525': {
		name: '4525',
		r: 0.8,
		g: 0.749019607843137,
		b: 0.556862745098039
	},
	'p453': {
		name: '453',
		r: 0.83921568627451,
		g: 0.8,
		b: 0.686274509803922
	},
	'p4535': {
		name: '4535',
		r: 0.858823529411765,
		g: 0.807843137254902,
		b: 0.647058823529412
	},
	'p454': {
		name: '454',
		r: 0.886274509803922,
		g: 0.847058823529412,
		b: 0.749019607843137
	},
	'p4545': {
		name: '4545',
		r: 0.898039215686275,
		g: 0.858823529411765,
		b: 0.729411764705882
	},
	'p455': {
		name: '455',
		r: 0.4,
		g: 0.337254901960784,
		b: 0.0784313725490196
	},
	'p456': {
		name: '456',
		r: 0.6,
		g: 0.529411764705882,
		b: 0.0784313725490196
	},
	'p457': {
		name: '457',
		r: 0.709803921568627,
		g: 0.607843137254902,
		b: 0.0470588235294118
	},
	'p458': {
		name: '458',
		r: 0.866666666666667,
		g: 0.8,
		b: 0.419607843137255
	},
	'p459': {
		name: '459',
		r: 0.886274509803922,
		g: 0.83921568627451,
		b: 0.486274509803922
	},
	'p460': {
		name: '460',
		r: 0.917647058823529,
		g: 0.866666666666667,
		b: 0.588235294117647
	},
	'p461': {
		name: '461',
		r: 0.929411764705882,
		g: 0.898039215686275,
		b: 0.67843137254902
	},
	'p462': {
		name: '462',
		r: 0.356862745098039,
		g: 0.27843137254902,
		b: 0.137254901960784
	},
	'p4625': {
		name: '4625',
		r: 0.27843137254902,
		g: 0.137254901960784,
		b: 0.0666666666666667
	},
	'p463': {
		name: '463',
		r: 0.458823529411765,
		g: 0.329411764705882,
		b: 0.149019607843137
	},
	'p4635': {
		name: '4635',
		r: 0.549019607843137,
		g: 0.349019607843137,
		b: 0.2
	},
	'p464': {
		name: '464',
		r: 0.529411764705882,
		g: 0.376470588235294,
		b: 0.156862745098039
	},
	'p464 2X': {
		name: '464 2X',
		r: 0.43921568627451,
		g: 0.258823529411765,
		b: 0.0784313725490196
	},
	'p4645': {
		name: '4645',
		r: 0.698039215686274,
		g: 0.509803921568627,
		b: 0.376470588235294
	},
	'p465': {
		name: '465',
		r: 0.756862745098039,
		g: 0.658823529411765,
		b: 0.458823529411765
	},
	'p4655': {
		name: '4655',
		r: 0.768627450980392,
		g: 0.6,
		b: 0.466666666666667
	},
	'p466': {
		name: '466',
		r: 0.819607843137255,
		g: 0.749019607843137,
		b: 0.568627450980392
	},
	'p4665': {
		name: '4665',
		r: 0.847058823529412,
		g: 0.709803921568627,
		b: 0.588235294117647
	},
	'p467': {
		name: '467',
		r: 0.866666666666667,
		g: 0.8,
		b: 0.647058823529412
	},
	'p4675': {
		name: '4675',
		r: 0.898039215686275,
		g: 0.776470588235294,
		b: 0.666666666666667
	},
	'p468': {
		name: '468',
		r: 0.886274509803922,
		g: 0.83921568627451,
		b: 0.709803921568627
	},
	'p4685': {
		name: '4685',
		r: 0.929411764705882,
		g: 0.827450980392157,
		b: 0.737254901960784
	},
	'p469': {
		name: '469',
		r: 0.376470588235294,
		g: 0.2,
		b: 0.0666666666666667
	},
	'p4695': {
		name: '4695',
		r: 0.317647058823529,
		g: 0.149019607843137,
		b: 0.109803921568627
	},
	'p470': {
		name: '470',
		r: 0.607843137254902,
		g: 0.309803921568627,
		b: 0.0980392156862745
	},
	'p4705': {
		name: '4705',
		r: 0.486274509803922,
		g: 0.317647058823529,
		b: 0.23921568627451
	},
	'p471': {
		name: '471',
		r: 0.737254901960784,
		g: 0.368627450980392,
		b: 0.117647058823529
	},
	'p471 2X': {
		name: '471 2X',
		r: 0.63921568627451,
		g: 0.266666666666667,
		b: 0.00784313725490196
	},
	'p4715': {
		name: '4715',
		r: 0.6,
		g: 0.43921568627451,
		b: 0.356862745098039
	},
	'p472': {
		name: '472',
		r: 0.917647058823529,
		g: 0.666666666666667,
		b: 0.47843137254902
	},
	'p4725': {
		name: '4725',
		r: 0.709803921568627,
		g: 0.568627450980392,
		b: 0.486274509803922
	},
	'p473': {
		name: '473',
		r: 0.956862745098039,
		g: 0.768627450980392,
		b: 0.627450980392157
	},
	'p4735': {
		name: '4735',
		r: 0.8,
		g: 0.686274509803922,
		b: 0.607843137254902
	},
	'p474': {
		name: '474',
		r: 0.956862745098039,
		g: 0.8,
		b: 0.666666666666667
	},
	'p4745': {
		name: '4745',
		r: 0.847058823529412,
		g: 0.749019607843137,
		b: 0.666666666666667
	},
	'p475': {
		name: '475',
		r: 0.968627450980392,
		g: 0.827450980392157,
		b: 0.709803921568627
	},
	'p4755': {
		name: '4755',
		r: 0.886274509803922,
		g: 0.8,
		b: 0.729411764705882
	},
	'p476': {
		name: '476',
		r: 0.349019607843137,
		g: 0.23921568627451,
		b: 0.168627450980392
	},
	'p477': {
		name: '477',
		r: 0.388235294117647,
		g: 0.219607843137255,
		b: 0.149019607843137
	},
	'p478': {
		name: '478',
		r: 0.47843137254902,
		g: 0.247058823529412,
		b: 0.156862745098039
	},
	'p479': {
		name: '479',
		r: 0.686274509803922,
		g: 0.537254901960784,
		b: 0.43921568627451
	},
	'p480': {
		name: '480',
		r: 0.827450980392157,
		g: 0.717647058823529,
		b: 0.63921568627451
	},
	'p481': {
		name: '481',
		r: 0.87843137254902,
		g: 0.8,
		b: 0.729411764705882
	},
	'p482': {
		name: '482',
		r: 0.898039215686275,
		g: 0.827450980392157,
		b: 0.756862745098039
	},
	'p483': {
		name: '483',
		r: 0.419607843137255,
		g: 0.188235294117647,
		b: 0.129411764705882
	},
	'p484': {
		name: '484',
		r: 0.607843137254902,
		g: 0.188235294117647,
		b: 0.109803921568627
	},
	'p485': {
		name: '485',
		r: 0.847058823529412,
		g: 0.117647058823529,
		b: 0.0196078431372549
	},
	'p485 2X': {
		name: '485 2X',
		r: 0.8,
		g: 0.0470588235294118,
		b: 0
	},
	'p486': {
		name: '486',
		r: 0.929411764705882,
		g: 0.619607843137255,
		b: 0.517647058823529
	},
	'p487': {
		name: '487',
		r: 0.937254901960784,
		g: 0.709803921568627,
		b: 0.627450980392157
	},
	'p488': {
		name: '488',
		r: 0.949019607843137,
		g: 0.768627450980392,
		b: 0.686274509803922
	},
	'p489': {
		name: '489',
		r: 0.949019607843137,
		g: 0.819607843137255,
		b: 0.749019607843137
	},
	'p490': {
		name: '490',
		r: 0.356862745098039,
		g: 0.149019607843137,
		b: 0.149019607843137
	},
	'p491': {
		name: '491',
		r: 0.458823529411765,
		g: 0.156862745098039,
		b: 0.156862745098039
	},
	'p492': {
		name: '492',
		r: 0.568627450980392,
		g: 0.2,
		b: 0.219607843137255
	},
	'p494': {
		name: '494',
		r: 0.949019607843137,
		g: 0.67843137254902,
		b: 0.698039215686274
	},
	'p495': {
		name: '495',
		r: 0.956862745098039,
		g: 0.737254901960784,
		b: 0.749019607843137
	},
	'p496': {
		name: '496',
		r: 0.968627450980392,
		g: 0.788235294117647,
		b: 0.776470588235294
	},
	'p497': {
		name: '497',
		r: 0.317647058823529,
		g: 0.156862745098039,
		b: 0.149019607843137
	},
	'p4975': {
		name: '4975',
		r: 0.266666666666667,
		g: 0.117647058823529,
		b: 0.109803921568627
	},
	'p498': {
		name: '498',
		r: 0.427450980392157,
		g: 0.2,
		b: 0.168627450980392
	},
	'p4985': {
		name: '4985',
		r: 0.517647058823529,
		g: 0.286274509803922,
		b: 0.286274509803922
	},
	'p499': {
		name: '499',
		r: 0.47843137254902,
		g: 0.219607843137255,
		b: 0.176470588235294
	},
	'p4995': {
		name: '4995',
		r: 0.647058823529412,
		g: 0.419607843137255,
		b: 0.427450980392157
	},
	'p500': {
		name: '500',
		r: 0.807843137254902,
		g: 0.537254901960784,
		b: 0.549019607843137
	},
	'p5005': {
		name: '5005',
		r: 0.737254901960784,
		g: 0.529411764705882,
		b: 0.529411764705882
	},
	'p501': {
		name: '501',
		r: 0.917647058823529,
		g: 0.698039215686274,
		b: 0.698039215686274
	},
	'p5015': {
		name: '5015',
		r: 0.847058823529412,
		g: 0.67843137254902,
		b: 0.658823529411765
	},
	'p502': {
		name: '502',
		r: 0.949019607843137,
		g: 0.776470588235294,
		b: 0.768627450980392
	},
	'p5025': {
		name: '5025',
		r: 0.886274509803922,
		g: 0.737254901960784,
		b: 0.717647058823529
	},
	'p503': {
		name: '503',
		r: 0.956862745098039,
		g: 0.819607843137255,
		b: 0.8
	},
	'p5035': {
		name: '5035',
		r: 0.929411764705882,
		g: 0.807843137254902,
		b: 0.776470588235294
	},
	'p504': {
		name: '504',
		r: 0.317647058823529,
		g: 0.117647058823529,
		b: 0.149019607843137
	},
	'p505': {
		name: '505',
		r: 0.4,
		g: 0.117647058823529,
		b: 0.168627450980392
	},
	'p506': {
		name: '506',
		r: 0.47843137254902,
		g: 0.149019607843137,
		b: 0.219607843137255
	},
	'p507': {
		name: '507',
		r: 0.847058823529412,
		g: 0.537254901960784,
		b: 0.607843137254902
	},
	'p508': {
		name: '508',
		r: 0.909803921568627,
		g: 0.647058823529412,
		b: 0.686274509803922
	},
	'p509': {
		name: '509',
		r: 0.949019607843137,
		g: 0.729411764705882,
		b: 0.749019607843137
	},
	'p510': {
		name: '510',
		r: 0.956862745098039,
		g: 0.776470588235294,
		b: 0.788235294117647
	},
	'p511': {
		name: '511',
		r: 0.376470588235294,
		g: 0.129411764705882,
		b: 0.266666666666667
	},
	'p5115': {
		name: '5115',
		r: 0.309803921568627,
		g: 0.129411764705882,
		b: 0.227450980392157
	},
	'p512': {
		name: '512',
		r: 0.517647058823529,
		g: 0.129411764705882,
		b: 0.419607843137255
	},
	'p5125': {
		name: '5125',
		r: 0.458823529411765,
		g: 0.27843137254902,
		b: 0.376470588235294
	},
	'p513': {
		name: '513',
		r: 0.619607843137255,
		g: 0.137254901960784,
		b: 0.529411764705882
	},
	'p5135': {
		name: '5135',
		r: 0.576470588235294,
		g: 0.419607843137255,
		b: 0.498039215686275
	},
	'p514': {
		name: '514',
		r: 0.847058823529412,
		g: 0.517647058823529,
		b: 0.737254901960784
	},
	'p5145': {
		name: '5145',
		r: 0.67843137254902,
		g: 0.529411764705882,
		b: 0.6
	},
	'p515': {
		name: '515',
		r: 0.909803921568627,
		g: 0.63921568627451,
		b: 0.788235294117647
	},
	'p5155': {
		name: '5155',
		r: 0.8,
		g: 0.686274509803922,
		b: 0.717647058823529
	},
	'p516': {
		name: '516',
		r: 0.949019607843137,
		g: 0.729411764705882,
		b: 0.827450980392157
	},
	'p5165': {
		name: '5165',
		r: 0.87843137254902,
		g: 0.788235294117647,
		b: 0.8
	},
	'p517': {
		name: '517',
		r: 0.956862745098039,
		g: 0.8,
		b: 0.847058823529412
	},
	'p5175': {
		name: '5175',
		r: 0.909803921568627,
		g: 0.83921568627451,
		b: 0.819607843137255
	},
	'p518': {
		name: '518',
		r: 0.317647058823529,
		g: 0.176470588235294,
		b: 0.266666666666667
	},
	'p5185': {
		name: '5185',
		r: 0.27843137254902,
		g: 0.156862745098039,
		b: 0.207843137254902
	},
	'p519': {
		name: '519',
		r: 0.388235294117647,
		g: 0.188235294117647,
		b: 0.368627450980392
	},
	'p5195': {
		name: '5195',
		r: 0.349019607843137,
		g: 0.2,
		b: 0.266666666666667
	},
	'p520': {
		name: '520',
		r: 0.43921568627451,
		g: 0.207843137254902,
		b: 0.447058823529412
	},
	'p5205': {
		name: '5205',
		r: 0.556862745098039,
		g: 0.407843137254902,
		b: 0.466666666666667
	},
	'p521': {
		name: '521',
		r: 0.709803921568627,
		g: 0.549019607843137,
		b: 0.698039215686274
	},
	'p5215': {
		name: '5215',
		r: 0.709803921568627,
		g: 0.576470588235294,
		b: 0.607843137254902
	},
	'p522': {
		name: '522',
		r: 0.776470588235294,
		g: 0.63921568627451,
		b: 0.756862745098039
	},
	'p5225': {
		name: '5225',
		r: 0.8,
		g: 0.67843137254902,
		b: 0.686274509803922
	},
	'p523': {
		name: '523',
		r: 0.827450980392157,
		g: 0.717647058823529,
		b: 0.8
	},
	'p5235': {
		name: '5235',
		r: 0.866666666666667,
		g: 0.776470588235294,
		b: 0.768627450980392
	},
	'p524': {
		name: '524',
		r: 0.886274509803922,
		g: 0.8,
		b: 0.827450980392157
	},
	'p5245': {
		name: '5245',
		r: 0.898039215686275,
		g: 0.827450980392157,
		b: 0.8
	},
	'p525': {
		name: '525',
		r: 0.317647058823529,
		g: 0.149019607843137,
		b: 0.329411764705882
	},
	'p5255': {
		name: '5255',
		r: 0.207843137254902,
		g: 0.149019607843137,
		b: 0.309803921568627
	},
	'p526': {
		name: '526',
		r: 0.407843137254902,
		g: 0.129411764705882,
		b: 0.47843137254902
	},
	'p5265': {
		name: '5265',
		r: 0.286274509803922,
		g: 0.23921568627451,
		b: 0.388235294117647
	},
	'p527': {
		name: '527',
		r: 0.47843137254902,
		g: 0.117647058823529,
		b: 0.6
	},
	'p5275': {
		name: '5275',
		r: 0.376470588235294,
		g: 0.337254901960784,
		b: 0.466666666666667
	},
	'p528': {
		name: '528',
		r: 0.686274509803922,
		g: 0.447058823529412,
		b: 0.756862745098039
	},
	'p5285': {
		name: '5285',
		r: 0.549019607843137,
		g: 0.509803921568627,
		b: 0.6
	},
	'p529': {
		name: '529',
		r: 0.807843137254902,
		g: 0.63921568627451,
		b: 0.827450980392157
	},
	'p5295': {
		name: '5295',
		r: 0.698039215686274,
		g: 0.658823529411765,
		b: 0.709803921568627
	},
	'p530': {
		name: '530',
		r: 0.83921568627451,
		g: 0.686274509803922,
		b: 0.83921568627451
	},
	'p5305': {
		name: '5305',
		r: 0.8,
		g: 0.756862745098039,
		b: 0.776470588235294
	},
	'p531': {
		name: '531',
		r: 0.898039215686275,
		g: 0.776470588235294,
		b: 0.858823529411765
	},
	'p5315': {
		name: '5315',
		r: 0.858823529411765,
		g: 0.827450980392157,
		b: 0.827450980392157
	},
	'p532': {
		name: '532',
		r: 0.207843137254902,
		g: 0.219607843137255,
		b: 0.258823529411765
	},
	'p533': {
		name: '533',
		r: 0.207843137254902,
		g: 0.247058823529412,
		b: 0.356862745098039
	},
	'p534': {
		name: '534',
		r: 0.227450980392157,
		g: 0.286274509803922,
		b: 0.447058823529412
	},
	'p535': {
		name: '535',
		r: 0.607843137254902,
		g: 0.63921568627451,
		b: 0.717647058823529
	},
	'p536': {
		name: '536',
		r: 0.67843137254902,
		g: 0.698039215686274,
		b: 0.756862745098039
	},
	'p537': {
		name: '537',
		r: 0.768627450980392,
		g: 0.776470588235294,
		b: 0.807843137254902
	},
	'p538': {
		name: '538',
		r: 0.83921568627451,
		g: 0.827450980392157,
		b: 0.83921568627451
	},
	'p539': {
		name: '539',
		r: 0,
		g: 0.188235294117647,
		b: 0.286274509803922
	},
	'p5395': {
		name: '5395',
		r: 0.00784313725490196,
		g: 0.156862745098039,
		b: 0.227450980392157
	},
	'p540': {
		name: '540',
		r: 0,
		g: 0.2,
		b: 0.356862745098039
	},
	'p5405': {
		name: '5405',
		r: 0.247058823529412,
		g: 0.376470588235294,
		b: 0.458823529411765
	},
	'p541': {
		name: '541',
		r: 0,
		g: 0.247058823529412,
		b: 0.466666666666667
	},
	'p5415': {
		name: '5415',
		r: 0.376470588235294,
		g: 0.486274509803922,
		b: 0.549019607843137
	},
	'p542': {
		name: '542',
		r: 0.4,
		g: 0.576470588235294,
		b: 0.737254901960784
	},
	'p5425': {
		name: '5425',
		r: 0.517647058823529,
		g: 0.6,
		b: 0.647058823529412
	},
	'p543': {
		name: '543',
		r: 0.576470588235294,
		g: 0.717647058823529,
		b: 0.819607843137255
	},
	'p5435': {
		name: '5435',
		r: 0.686274509803922,
		g: 0.737254901960784,
		b: 0.749019607843137
	},
	'p544': {
		name: '544',
		r: 0.717647058823529,
		g: 0.8,
		b: 0.858823529411765
	},
	'p5445': {
		name: '5445',
		r: 0.768627450980392,
		g: 0.8,
		b: 0.8
	},
	'p545': {
		name: '545',
		r: 0.768627450980392,
		g: 0.827450980392157,
		b: 0.866666666666667
	},
	'p5455': {
		name: '5455',
		r: 0.83921568627451,
		g: 0.847058823529412,
		b: 0.827450980392157
	},
	'p546': {
		name: '546',
		r: 0.0470588235294118,
		g: 0.219607843137255,
		b: 0.266666666666667
	},
	'p5463': {
		name: '5463',
		r: 0,
		g: 0.207843137254902,
		b: 0.227450980392157
	},
	'p5467': {
		name: '5467',
		r: 0.0980392156862745,
		g: 0.219607843137255,
		b: 0.2
	},
	'p547': {
		name: '547',
		r: 0,
		g: 0.247058823529412,
		b: 0.329411764705882
	},
	'p5473': {
		name: '5473',
		r: 0.149019607843137,
		g: 0.407843137254902,
		b: 0.427450980392157
	},
	'p5477': {
		name: '5477',
		r: 0.227450980392157,
		g: 0.337254901960784,
		b: 0.309803921568627
	},
	'p548': {
		name: '548',
		r: 0,
		g: 0.266666666666667,
		b: 0.349019607843137
	},
	'p5483': {
		name: '5483',
		r: 0.376470588235294,
		g: 0.568627450980392,
		b: 0.568627450980392
	},
	'p5487': {
		name: '5487',
		r: 0.4,
		g: 0.486274509803922,
		b: 0.447058823529412
	},
	'p549': {
		name: '549',
		r: 0.368627450980392,
		g: 0.6,
		b: 0.666666666666667
	},
	'p5493': {
		name: '5493',
		r: 0.549019607843137,
		g: 0.686274509803922,
		b: 0.67843137254902
	},
	'p5497': {
		name: '5497',
		r: 0.568627450980392,
		g: 0.63921568627451,
		b: 0.6
	},
	'p550': {
		name: '550',
		r: 0.529411764705882,
		g: 0.686274509803922,
		b: 0.749019607843137
	},
	'p5503': {
		name: '5503',
		r: 0.666666666666667,
		g: 0.768627450980392,
		b: 0.749019607843137
	},
	'p5507': {
		name: '5507',
		r: 0.686274509803922,
		g: 0.729411764705882,
		b: 0.698039215686274
	},
	'p551': {
		name: '551',
		r: 0.63921568627451,
		g: 0.756862745098039,
		b: 0.788235294117647
	},
	'p5513': {
		name: '5513',
		r: 0.807843137254902,
		g: 0.847058823529412,
		b: 0.819607843137255
	},
	'p5517': {
		name: '5517',
		r: 0.788235294117647,
		g: 0.807843137254902,
		b: 0.768627450980392
	},
	'p552': {
		name: '552',
		r: 0.768627450980392,
		g: 0.83921568627451,
		b: 0.83921568627451
	},
	'p5523': {
		name: '5523',
		r: 0.83921568627451,
		g: 0.866666666666667,
		b: 0.83921568627451
	},
	'p5527': {
		name: '5527',
		r: 0.807843137254902,
		g: 0.819607843137255,
		b: 0.776470588235294
	},
	'p553': {
		name: '553',
		r: 0.137254901960784,
		g: 0.266666666666667,
		b: 0.207843137254902
	},
	'p5535': {
		name: '5535',
		r: 0.129411764705882,
		g: 0.23921568627451,
		b: 0.188235294117647
	},
	'p554': {
		name: '554',
		r: 0.0980392156862745,
		g: 0.368627450980392,
		b: 0.27843137254902
	},
	'p5545': {
		name: '5545',
		r: 0.309803921568627,
		g: 0.427450980392157,
		b: 0.368627450980392
	},
	'p555': {
		name: '555',
		r: 0.0274509803921569,
		g: 0.427450980392157,
		b: 0.329411764705882
	},
	'p5555': {
		name: '5555',
		r: 0.466666666666667,
		g: 0.568627450980392,
		b: 0.509803921568627
	},
	'p556': {
		name: '556',
		r: 0.47843137254902,
		g: 0.658823529411765,
		b: 0.568627450980392
	},
	'p5565': {
		name: '5565',
		r: 0.588235294117647,
		g: 0.666666666666667,
		b: 0.6
	},
	'p557': {
		name: '557',
		r: 0.63921568627451,
		g: 0.756862745098039,
		b: 0.67843137254902
	},
	'p5575': {
		name: '5575',
		r: 0.686274509803922,
		g: 0.749019607843137,
		b: 0.67843137254902
	},
	'p558': {
		name: '558',
		r: 0.717647058823529,
		g: 0.807843137254902,
		b: 0.737254901960784
	},
	'p5585': {
		name: '5585',
		r: 0.768627450980392,
		g: 0.807843137254902,
		b: 0.749019607843137
	},
	'p559': {
		name: '559',
		r: 0.776470588235294,
		g: 0.83921568627451,
		b: 0.768627450980392
	},
	'p5595': {
		name: '5595',
		r: 0.847058823529412,
		g: 0.858823529411765,
		b: 0.8
	},
	'p560': {
		name: '560',
		r: 0.168627450980392,
		g: 0.298039215686275,
		b: 0.247058823529412
	},
	'p5605': {
		name: '5605',
		r: 0.137254901960784,
		g: 0.227450980392157,
		b: 0.176470588235294
	},
	'p561': {
		name: '561',
		r: 0.149019607843137,
		g: 0.4,
		b: 0.349019607843137
	},
	'p5615': {
		name: '5615',
		r: 0.329411764705882,
		g: 0.407843137254902,
		b: 0.337254901960784
	},
	'p562': {
		name: '562',
		r: 0.117647058823529,
		g: 0.47843137254902,
		b: 0.427450980392157
	},
	'p5625': {
		name: '5625',
		r: 0.447058823529412,
		g: 0.517647058823529,
		b: 0.43921568627451
	},
	'p563': {
		name: '563',
		r: 0.498039215686275,
		g: 0.737254901960784,
		b: 0.666666666666667
	},
	'p5635': {
		name: '5635',
		r: 0.619607843137255,
		g: 0.666666666666667,
		b: 0.6
	},
	'p564': {
		name: '564',
		r: 0.0196078431372549,
		g: 0.43921568627451,
		b: 0.368627450980392
	},
	'p5645': {
		name: '5645',
		r: 0.737254901960784,
		g: 0.756862745098039,
		b: 0.698039215686274
	},
	'p565': {
		name: '565',
		r: 0.737254901960784,
		g: 0.858823529411765,
		b: 0.8
	},
	'p5655': {
		name: '5655',
		r: 0.776470588235294,
		g: 0.8,
		b: 0.729411764705882
	},
	'p566': {
		name: '566',
		r: 0.819607843137255,
		g: 0.886274509803922,
		b: 0.827450980392157
	},
	'p5665': {
		name: '5665',
		r: 0.83921568627451,
		g: 0.83921568627451,
		b: 0.776470588235294
	},
	'p567': {
		name: '567',
		r: 0.149019607843137,
		g: 0.317647058823529,
		b: 0.258823529411765
	},
	'p568': {
		name: '568',
		r: 0,
		g: 0.447058823529412,
		b: 0.388235294117647
	},
	'p569': {
		name: '569',
		r: 0,
		g: 0.529411764705882,
		b: 0.447058823529412
	},
	'p570': {
		name: '570',
		r: 0.498039215686275,
		g: 0.776470588235294,
		b: 0.698039215686274
	},
	'p571': {
		name: '571',
		r: 0.666666666666667,
		g: 0.858823529411765,
		b: 0.776470588235294
	},
	'p572': {
		name: '572',
		r: 0.737254901960784,
		g: 0.886274509803922,
		b: 0.807843137254902
	},
	'p573': {
		name: '573',
		r: 0.8,
		g: 0.898039215686275,
		b: 0.83921568627451
	},
	'p574': {
		name: '574',
		r: 0.286274509803922,
		g: 0.349019607843137,
		b: 0.156862745098039
	},
	'p5743': {
		name: '5743',
		r: 0.247058823529412,
		g: 0.286274509803922,
		b: 0.149019607843137
	},
	'p5747': {
		name: '5747',
		r: 0.258823529411765,
		g: 0.27843137254902,
		b: 0.0862745098039216
	},
	'p575': {
		name: '575',
		r: 0.329411764705882,
		g: 0.466666666666667,
		b: 0.188235294117647
	},
	'p5753': {
		name: '5753',
		r: 0.368627450980392,
		g: 0.4,
		b: 0.227450980392157
	},
	'p5757': {
		name: '5757',
		r: 0.419607843137255,
		g: 0.43921568627451,
		b: 0.168627450980392
	},
	'p576': {
		name: '576',
		r: 0.376470588235294,
		g: 0.556862745098039,
		b: 0.227450980392157
	},
	'p5763': {
		name: '5763',
		r: 0.466666666666667,
		g: 0.486274509803922,
		b: 0.309803921568627
	},
	'p5767': {
		name: '5767',
		r: 0.549019607843137,
		g: 0.568627450980392,
		b: 0.309803921568627
	},
	'p577': {
		name: '577',
		r: 0.709803921568627,
		g: 0.8,
		b: 0.556862745098039
	},
	'p5773': {
		name: '5773',
		r: 0.607843137254902,
		g: 0.619607843137255,
		b: 0.447058823529412
	},
	'p5777': {
		name: '5777',
		r: 0.666666666666667,
		g: 0.67843137254902,
		b: 0.458823529411765
	},
	'p578': {
		name: '578',
		r: 0.776470588235294,
		g: 0.83921568627451,
		b: 0.627450980392157
	},
	'p5783': {
		name: '5783',
		r: 0.709803921568627,
		g: 0.709803921568627,
		b: 0.556862745098039
	},
	'p5787': {
		name: '5787',
		r: 0.776470588235294,
		g: 0.776470588235294,
		b: 0.6
	},
	'p579': {
		name: '579',
		r: 0.788235294117647,
		g: 0.83921568627451,
		b: 0.63921568627451
	},
	'p5793': {
		name: '5793',
		r: 0.776470588235294,
		g: 0.776470588235294,
		b: 0.647058823529412
	},
	'p5797': {
		name: '5797',
		r: 0.827450980392157,
		g: 0.819607843137255,
		b: 0.666666666666667
	},
	'p580': {
		name: '580',
		r: 0.847058823529412,
		g: 0.866666666666667,
		b: 0.709803921568627
	},
	'p5803': {
		name: '5803',
		r: 0.847058823529412,
		g: 0.83921568627451,
		b: 0.717647058823529
	},
	'p5807': {
		name: '5807',
		r: 0.87843137254902,
		g: 0.866666666666667,
		b: 0.737254901960784
	},
	'p581': {
		name: '581',
		r: 0.376470588235294,
		g: 0.368627450980392,
		b: 0.0666666666666667
	},
	'p5815': {
		name: '5815',
		r: 0.286274509803922,
		g: 0.266666666666667,
		b: 0.0666666666666667
	},
	'p582': {
		name: '582',
		r: 0.529411764705882,
		g: 0.537254901960784,
		b: 0.0196078431372549
	},
	'p5825': {
		name: '5825',
		r: 0.458823529411765,
		g: 0.43921568627451,
		b: 0.168627450980392
	},
	'p583': {
		name: '583',
		r: 0.666666666666667,
		g: 0.729411764705882,
		b: 0.0392156862745098
	},
	'p5835': {
		name: '5835',
		r: 0.619607843137255,
		g: 0.6,
		b: 0.349019607843137
	},
	'p584': {
		name: '584',
		r: 0.807843137254902,
		g: 0.83921568627451,
		b: 0.286274509803922
	},
	'p5845': {
		name: '5845',
		r: 0.698039215686274,
		g: 0.666666666666667,
		b: 0.43921568627451
	},
	'p585': {
		name: '585',
		r: 0.858823529411765,
		g: 0.87843137254902,
		b: 0.419607843137255
	},
	'p5855': {
		name: '5855',
		r: 0.8,
		g: 0.776470588235294,
		b: 0.576470588235294
	},
	'p586': {
		name: '586',
		r: 0.886274509803922,
		g: 0.898039215686275,
		b: 0.517647058823529
	},
	'p5865': {
		name: '5865',
		r: 0.83921568627451,
		g: 0.807843137254902,
		b: 0.63921568627451
	},
	'p587': {
		name: '587',
		r: 0.909803921568627,
		g: 0.909803921568627,
		b: 0.607843137254902
	},
	'p5875': {
		name: '5875',
		r: 0.87843137254902,
		g: 0.858823529411765,
		b: 0.709803921568627
	},
	'p600': {
		name: '600',
		r: 0.956862745098039,
		g: 0.929411764705882,
		b: 0.686274509803922
	},
	'p601': {
		name: '601',
		r: 0.949019607843137,
		g: 0.929411764705882,
		b: 0.619607843137255
	},
	'p602': {
		name: '602',
		r: 0.949019607843137,
		g: 0.917647058823529,
		b: 0.529411764705882
	},
	'p603': {
		name: '603',
		r: 0.929411764705882,
		g: 0.909803921568627,
		b: 0.356862745098039
	},
	'p604': {
		name: '604',
		r: 0.909803921568627,
		g: 0.866666666666667,
		b: 0.129411764705882
	},
	'p605': {
		name: '605',
		r: 0.866666666666667,
		g: 0.807843137254902,
		b: 0.0666666666666667
	},
	'p606': {
		name: '606',
		r: 0.827450980392157,
		g: 0.749019607843137,
		b: 0.0666666666666667
	},
	'p607': {
		name: '607',
		r: 0.949019607843137,
		g: 0.917647058823529,
		b: 0.737254901960784
	},
	'p608': {
		name: '608',
		r: 0.937254901960784,
		g: 0.909803921568627,
		b: 0.67843137254902
	},
	'p609': {
		name: '609',
		r: 0.917647058823529,
		g: 0.898039215686275,
		b: 0.588235294117647
	},
	'p610': {
		name: '610',
		r: 0.886274509803922,
		g: 0.858823529411765,
		b: 0.447058823529412
	},
	'p611': {
		name: '611',
		r: 0.83921568627451,
		g: 0.807843137254902,
		b: 0.286274509803922
	},
	'p612': {
		name: '612',
		r: 0.768627450980392,
		g: 0.729411764705882,
		b: 0
	},
	'p613': {
		name: '613',
		r: 0.686274509803922,
		g: 0.627450980392157,
		b: 0.0470588235294118
	},
	'p614': {
		name: '614',
		r: 0.917647058823529,
		g: 0.886274509803922,
		b: 0.717647058823529
	},
	'p615': {
		name: '615',
		r: 0.886274509803922,
		g: 0.858823529411765,
		b: 0.666666666666667
	},
	'p616': {
		name: '616',
		r: 0.866666666666667,
		g: 0.83921568627451,
		b: 0.607843137254902
	},
	'p617': {
		name: '617',
		r: 0.8,
		g: 0.768627450980392,
		b: 0.486274509803922
	},
	'p618': {
		name: '618',
		r: 0.709803921568627,
		g: 0.666666666666667,
		b: 0.349019607843137
	},
	'p619': {
		name: '619',
		r: 0.588235294117647,
		g: 0.549019607843137,
		b: 0.156862745098039
	},
	'p620': {
		name: '620',
		r: 0.517647058823529,
		g: 0.466666666666667,
		b: 0.0666666666666667
	},
	'p621': {
		name: '621',
		r: 0.847058823529412,
		g: 0.866666666666667,
		b: 0.807843137254902
	},
	'p622': {
		name: '622',
		r: 0.756862745098039,
		g: 0.819607843137255,
		b: 0.749019607843137
	},
	'p623': {
		name: '623',
		r: 0.647058823529412,
		g: 0.749019607843137,
		b: 0.666666666666667
	},
	'p624': {
		name: '624',
		r: 0.498039215686275,
		g: 0.627450980392157,
		b: 0.549019607843137
	},
	'p625': {
		name: '625',
		r: 0.356862745098039,
		g: 0.529411764705882,
		b: 0.447058823529412
	},
	'p626': {
		name: '626',
		r: 0.129411764705882,
		g: 0.329411764705882,
		b: 0.247058823529412
	},
	'p627': {
		name: '627',
		r: 0.0470588235294118,
		g: 0.188235294117647,
		b: 0.149019607843137
	},
	'p628': {
		name: '628',
		r: 0.8,
		g: 0.886274509803922,
		b: 0.866666666666667
	},
	'p629': {
		name: '629',
		r: 0.698039215686274,
		g: 0.847058823529412,
		b: 0.847058823529412
	},
	'p630': {
		name: '630',
		r: 0.549019607843137,
		g: 0.8,
		b: 0.827450980392157
	},
	'p631': {
		name: '631',
		r: 0.329411764705882,
		g: 0.717647058823529,
		b: 0.776470588235294
	},
	'p632': {
		name: '632',
		r: 0,
		g: 0.627450980392157,
		b: 0.729411764705882
	},
	'p633': {
		name: '633',
		r: 0,
		g: 0.498039215686275,
		b: 0.6
	},
	'p634': {
		name: '634',
		r: 0,
		g: 0.4,
		b: 0.498039215686275
	},
	'p635': {
		name: '635',
		r: 0.729411764705882,
		g: 0.87843137254902,
		b: 0.87843137254902
	},
	'p636': {
		name: '636',
		r: 0.6,
		g: 0.83921568627451,
		b: 0.866666666666667
	},
	'p637': {
		name: '637',
		r: 0.419607843137255,
		g: 0.788235294117647,
		b: 0.858823529411765
	},
	'p638': {
		name: '638',
		r: 0,
		g: 0.709803921568627,
		b: 0.83921568627451
	},
	'p639': {
		name: '639',
		r: 0,
		g: 0.627450980392157,
		b: 0.768627450980392
	},
	'p640': {
		name: '640',
		r: 0,
		g: 0.549019607843137,
		b: 0.698039215686274
	},
	'p641': {
		name: '641',
		r: 0,
		g: 0.47843137254902,
		b: 0.647058823529412
	},
	'p642': {
		name: '642',
		r: 0.819607843137255,
		g: 0.847058823529412,
		b: 0.847058823529412
	},
	'p643': {
		name: '643',
		r: 0.776470588235294,
		g: 0.819607843137255,
		b: 0.83921568627451
	},
	'p644': {
		name: '644',
		r: 0.607843137254902,
		g: 0.686274509803922,
		b: 0.768627450980392
	},
	'p645': {
		name: '645',
		r: 0.466666666666667,
		g: 0.588235294117647,
		b: 0.698039215686274
	},
	'p646': {
		name: '646',
		r: 0.368627450980392,
		g: 0.509803921568627,
		b: 0.63921568627451
	},
	'p647': {
		name: '647',
		r: 0.149019607843137,
		g: 0.329411764705882,
		b: 0.486274509803922
	},
	'p648': {
		name: '648',
		r: 0,
		g: 0.188235294117647,
		b: 0.368627450980392
	},
	'p649': {
		name: '649',
		r: 0.83921568627451,
		g: 0.83921568627451,
		b: 0.847058823529412
	},
	'p650': {
		name: '650',
		r: 0.749019607843137,
		g: 0.776470588235294,
		b: 0.819607843137255
	},
	'p651': {
		name: '651',
		r: 0.607843137254902,
		g: 0.666666666666667,
		b: 0.749019607843137
	},
	'p652': {
		name: '652',
		r: 0.427450980392157,
		g: 0.529411764705882,
		b: 0.658823529411765
	},
	'p653': {
		name: '653',
		r: 0.2,
		g: 0.337254901960784,
		b: 0.529411764705882
	},
	'p654': {
		name: '654',
		r: 0.0588235294117647,
		g: 0.168627450980392,
		b: 0.356862745098039
	},
	'p655': {
		name: '655',
		r: 0.0470588235294118,
		g: 0.109803921568627,
		b: 0.27843137254902
	},
	'p656': {
		name: '656',
		r: 0.83921568627451,
		g: 0.858823529411765,
		b: 0.87843137254902
	},
	'p657': {
		name: '657',
		r: 0.756862745098039,
		g: 0.788235294117647,
		b: 0.866666666666667
	},
	'p658': {
		name: '658',
		r: 0.647058823529412,
		g: 0.686274509803922,
		b: 0.83921568627451
	},
	'p659': {
		name: '659',
		r: 0.498039215686275,
		g: 0.549019607843137,
		b: 0.749019607843137
	},
	'p660': {
		name: '660',
		r: 0.349019607843137,
		g: 0.376470588235294,
		b: 0.658823529411765
	},
	'p661': {
		name: '661',
		r: 0.176470588235294,
		g: 0.2,
		b: 0.556862745098039
	},
	'p662': {
		name: '662',
		r: 0.0470588235294118,
		g: 0.0980392156862745,
		b: 0.458823529411765
	},
	'p663': {
		name: '663',
		r: 0.886274509803922,
		g: 0.827450980392157,
		b: 0.83921568627451
	},
	'p664': {
		name: '664',
		r: 0.847058823529412,
		g: 0.8,
		b: 0.819607843137255
	},
	'p665': {
		name: '665',
		r: 0.776470588235294,
		g: 0.709803921568627,
		b: 0.768627450980392
	},
	'p666': {
		name: '666',
		r: 0.658823529411765,
		g: 0.576470588235294,
		b: 0.67843137254902
	},
	'p667': {
		name: '667',
		r: 0.498039215686275,
		g: 0.4,
		b: 0.537254901960784
	},
	'p668': {
		name: '668',
		r: 0.4,
		g: 0.286274509803922,
		b: 0.458823529411765
	},
	'p669': {
		name: '669',
		r: 0.27843137254902,
		g: 0.168627450980392,
		b: 0.349019607843137
	},
	'p670': {
		name: '670',
		r: 0.949019607843137,
		g: 0.83921568627451,
		b: 0.847058823529412
	},
	'p671': {
		name: '671',
		r: 0.937254901960784,
		g: 0.776470588235294,
		b: 0.827450980392157
	},
	'p672': {
		name: '672',
		r: 0.917647058823529,
		g: 0.666666666666667,
		b: 0.768627450980392
	},
	'p673': {
		name: '673',
		r: 0.87843137254902,
		g: 0.549019607843137,
		b: 0.698039215686274
	},
	'p674': {
		name: '674',
		r: 0.827450980392157,
		g: 0.419607843137255,
		b: 0.619607843137255
	},
	'p675': {
		name: '675',
		r: 0.737254901960784,
		g: 0.219607843137255,
		b: 0.466666666666667
	},
	'p676': {
		name: '676',
		r: 0.627450980392157,
		g: 0,
		b: 0.329411764705882
	},
	'p677': {
		name: '677',
		r: 0.929411764705882,
		g: 0.83921568627451,
		b: 0.83921568627451
	},
	'p678': {
		name: '678',
		r: 0.917647058823529,
		g: 0.8,
		b: 0.807843137254902
	},
	'p679': {
		name: '679',
		r: 0.898039215686275,
		g: 0.749019607843137,
		b: 0.776470588235294
	},
	'p680': {
		name: '680',
		r: 0.827450980392157,
		g: 0.619607843137255,
		b: 0.686274509803922
	},
	'p681': {
		name: '681',
		r: 0.717647058823529,
		g: 0.447058823529412,
		b: 0.556862745098039
	},
	'p682': {
		name: '682',
		r: 0.627450980392157,
		g: 0.317647058823529,
		b: 0.458823529411765
	},
	'p683': {
		name: '683',
		r: 0.498039215686275,
		g: 0.156862745098039,
		b: 0.309803921568627
	},
	'p684': {
		name: '684',
		r: 0.937254901960784,
		g: 0.8,
		b: 0.807843137254902
	},
	'p685': {
		name: '685',
		r: 0.917647058823529,
		g: 0.749019607843137,
		b: 0.768627450980392
	},
	'p686': {
		name: '686',
		r: 0.87843137254902,
		g: 0.666666666666667,
		b: 0.729411764705882
	},
	'p687': {
		name: '687',
		r: 0.788235294117647,
		g: 0.537254901960784,
		b: 0.619607843137255
	},
	'p688': {
		name: '688',
		r: 0.698039215686274,
		g: 0.4,
		b: 0.517647058823529
	},
	'p689': {
		name: '689',
		r: 0.576470588235294,
		g: 0.258823529411765,
		b: 0.4
	},
	'p690': {
		name: '690',
		r: 0.43921568627451,
		g: 0.137254901960784,
		b: 0.258823529411765
	},
	'p691': {
		name: '691',
		r: 0.937254901960784,
		g: 0.819607843137255,
		b: 0.788235294117647
	},
	'p692': {
		name: '692',
		r: 0.909803921568627,
		g: 0.749019607843137,
		b: 0.729411764705882
	},
	'p693': {
		name: '693',
		r: 0.858823529411765,
		g: 0.658823529411765,
		b: 0.647058823529412
	},
	'p694': {
		name: '694',
		r: 0.788235294117647,
		g: 0.549019607843137,
		b: 0.549019607843137
	},
	'p695': {
		name: '695',
		r: 0.698039215686274,
		g: 0.419607843137255,
		b: 0.43921568627451
	},
	'p696': {
		name: '696',
		r: 0.556862745098039,
		g: 0.27843137254902,
		b: 0.286274509803922
	},
	'p697': {
		name: '697',
		r: 0.498039215686275,
		g: 0.219607843137255,
		b: 0.227450980392157
	},
	'p698': {
		name: '698',
		r: 0.968627450980392,
		g: 0.819607843137255,
		b: 0.8
	},
	'p699': {
		name: '699',
		r: 0.968627450980392,
		g: 0.749019607843137,
		b: 0.749019607843137
	},
	'p700': {
		name: '700',
		r: 0.949019607843137,
		g: 0.647058823529412,
		b: 0.666666666666667
	},
	'p701': {
		name: '701',
		r: 0.909803921568627,
		g: 0.529411764705882,
		b: 0.556862745098039
	},
	'p702': {
		name: '702',
		r: 0.83921568627451,
		g: 0.376470588235294,
		b: 0.427450980392157
	},
	'p703': {
		name: '703',
		r: 0.717647058823529,
		g: 0.219607843137255,
		b: 0.266666666666667
	},
	'p704': {
		name: '704',
		r: 0.619607843137255,
		g: 0.156862745098039,
		b: 0.156862745098039
	},
	'p705': {
		name: '705',
		r: 0.976470588235294,
		g: 0.866666666666667,
		b: 0.83921568627451
	},
	'p706': {
		name: '706',
		r: 0.988235294117647,
		g: 0.788235294117647,
		b: 0.776470588235294
	},
	'p707': {
		name: '707',
		r: 0.988235294117647,
		g: 0.67843137254902,
		b: 0.686274509803922
	},
	'p708': {
		name: '708',
		r: 0.976470588235294,
		g: 0.556862745098039,
		b: 0.6
	},
	'p709': {
		name: '709',
		r: 0.949019607843137,
		g: 0.407843137254902,
		b: 0.466666666666667
	},
	'p710': {
		name: '710',
		r: 0.87843137254902,
		g: 0.258823529411765,
		b: 0.317647058823529
	},
	'p711': {
		name: '711',
		r: 0.819607843137255,
		g: 0.176470588235294,
		b: 0.2
	},
	'p712': {
		name: '712',
		r: 1,
		g: 0.827450980392157,
		b: 0.666666666666667
	},
	'p713': {
		name: '713',
		r: 0.976470588235294,
		g: 0.788235294117647,
		b: 0.63921568627451
	},
	'p714': {
		name: '714',
		r: 0.976470588235294,
		g: 0.729411764705882,
		b: 0.509803921568627
	},
	'p715': {
		name: '715',
		r: 0.988235294117647,
		g: 0.619607843137255,
		b: 0.286274509803922
	},
	'p716': {
		name: '716',
		r: 0.949019607843137,
		g: 0.517647058823529,
		b: 0.0666666666666667
	},
	'p717': {
		name: '717',
		r: 0.827450980392157,
		g: 0.427450980392157,
		b: 0
	},
	'p718': {
		name: '718',
		r: 0.749019607843137,
		g: 0.356862745098039,
		b: 0
	},
	'p719': {
		name: '719',
		r: 0.956862745098039,
		g: 0.819607843137255,
		b: 0.686274509803922
	},
	'p720': {
		name: '720',
		r: 0.937254901960784,
		g: 0.768627450980392,
		b: 0.619607843137255
	},
	'p721': {
		name: '721',
		r: 0.909803921568627,
		g: 0.698039215686274,
		b: 0.509803921568627
	},
	'p722': {
		name: '722',
		r: 0.819607843137255,
		g: 0.556862745098039,
		b: 0.329411764705882
	},
	'p723': {
		name: '723',
		r: 0.729411764705882,
		g: 0.458823529411765,
		b: 0.188235294117647
	},
	'p724': {
		name: '724',
		r: 0.556862745098039,
		g: 0.286274509803922,
		b: 0.0196078431372549
	},
	'p725': {
		name: '725',
		r: 0.458823529411765,
		g: 0.219607843137255,
		b: 0.00784313725490196
	},
	'p726': {
		name: '726',
		r: 0.929411764705882,
		g: 0.827450980392157,
		b: 0.709803921568627
	},
	'p727': {
		name: '727',
		r: 0.886274509803922,
		g: 0.749019607843137,
		b: 0.607843137254902
	},
	'p728': {
		name: '728',
		r: 0.827450980392157,
		g: 0.658823529411765,
		b: 0.486274509803922
	},
	'p729': {
		name: '729',
		r: 0.756862745098039,
		g: 0.556862745098039,
		b: 0.376470588235294
	},
	'p730': {
		name: '730',
		r: 0.666666666666667,
		g: 0.458823529411765,
		b: 0.247058823529412
	},
	'p731': {
		name: '731',
		r: 0.447058823529412,
		g: 0.247058823529412,
		b: 0.0392156862745098
	},
	'p732': {
		name: '732',
		r: 0.376470588235294,
		g: 0.2,
		b: 0.0392156862745098
	},
	'p801': {
		name: '801',
		r: 0,
		g: 0.666666666666667,
		b: 0.8
	},
	'p801 2X': {
		name: '801 2X',
		r: 0,
		g: 0.537254901960784,
		b: 0.686274509803922
	},
	'p802': {
		name: '802',
		r: 0.376470588235294,
		g: 0.866666666666667,
		b: 0.286274509803922
	},
	'p802 2X': {
		name: '802 2X',
		r: 0.109803921568627,
		g: 0.807843137254902,
		b: 0.156862745098039
	},
	'p803': {
		name: '803',
		r: 1,
		g: 0.929411764705882,
		b: 0.219607843137255
	},
	'p803 2X': {
		name: '803 2X',
		r: 1,
		g: 0.847058823529412,
		b: 0.0862745098039216
	},
	'p804': {
		name: '804',
		r: 1,
		g: 0.576470588235294,
		b: 0.219607843137255
	},
	'p804 2X': {
		name: '804 2X',
		r: 1,
		g: 0.498039215686275,
		b: 0.117647058823529
	},
	'p805': {
		name: '805',
		r: 0.976470588235294,
		g: 0.349019607843137,
		b: 0.317647058823529
	},
	'p805 2X': {
		name: '805 2X',
		r: 0.976470588235294,
		g: 0.227450980392157,
		b: 0.168627450980392
	},
	'p806': {
		name: '806',
		r: 1,
		g: 0,
		b: 0.576470588235294
	},
	'p806 2X': {
		name: '806 2X',
		r: 0.968627450980392,
		g: 0.00784313725490196,
		b: 0.486274509803922
	},
	'p807': {
		name: '807',
		r: 0.83921568627451,
		g: 0,
		b: 0.619607843137255
	},
	'p807 2X': {
		name: '807 2X',
		r: 0.749019607843137,
		g: 0,
		b: 0.549019607843137
	},
	'p808': {
		name: '808',
		r: 0,
		g: 0.709803921568627,
		b: 0.607843137254902
	},
	'p808 2X': {
		name: '808 2X',
		r: 0,
		g: 0.627450980392157,
		b: 0.529411764705882
	},
	'p809': {
		name: '809',
		r: 0.866666666666667,
		g: 0.87843137254902,
		b: 0.0588235294117647
	},
	'p809 2X': {
		name: '809 2X',
		r: 0.83921568627451,
		g: 0.83921568627451,
		b: 0.0470588235294118
	},
	'p810': {
		name: '810',
		r: 1,
		g: 0.8,
		b: 0.117647058823529
	},
	'p810 2X': {
		name: '810 2X',
		r: 1,
		g: 0.737254901960784,
		b: 0.129411764705882
	},
	'p811': {
		name: '811',
		r: 1,
		g: 0.447058823529412,
		b: 0.27843137254902
	},
	'p811 2X': {
		name: '811 2X',
		r: 1,
		g: 0.329411764705882,
		b: 0.0862745098039216
	},
	'p812': {
		name: '812',
		r: 0.988235294117647,
		g: 0.137254901960784,
		b: 0.4
	},
	'p812 2X': {
		name: '812 2X',
		r: 0.988235294117647,
		g: 0.0274509803921569,
		b: 0.309803921568627
	},
	'p813': {
		name: '813',
		r: 0.898039215686275,
		g: 0,
		b: 0.6
	},
	'p813 2X': {
		name: '813 2X',
		r: 0.819607843137255,
		g: 0,
		b: 0.517647058823529
	},
	'p814': {
		name: '814',
		r: 0.549019607843137,
		g: 0.376470588235294,
		b: 0.756862745098039
	},
	'p814 2X': {
		name: '814 2X',
		r: 0.43921568627451,
		g: 0.247058823529412,
		b: 0.686274509803922
	}
};
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  addToLocker = function(handle, url) {
    var quantity = 1 // parseInt($("input[name='quantity']").val());
    var lockerData = $.cookie('locker-data');
    console.log('product info', handle, url)
    var product = getProduct(url)
    if (!product) {
      alert('unable to add to locker, product not found')
      return
    }

    if (!product) return
    if (lockerData == null) {
      // no cookie
      lockerData = [];
    } else {
      // cookie
      lockerData = $.parseJSON($.cookie('locker-data'));
    }

    var handleFound = false;
    var itemFound;
    $.each(lockerData, function(index,value) {
      if (value.handle == handle) {
          itemFound = value;
          handleFound = true;
       }
    });

    if (handleFound) {
      alert("Item already in the locker");
      return
    }
    console.log('product', product)
    var newLockerItem = {};
    var price = getPrice(product, quantity);
    newLockerItem["id"] = product.id;
    newLockerItem["url"] = url;
    newLockerItem["img"] = product.image ? product.image.src : null; // product.featured_image | img_url: '180x', scale: 2 }}"
    newLockerItem["handle"] = product.handle;
    newLockerItem["title"] = product.title;
    newLockerItem["quantity"] = quantity;
    newLockerItem["price"] = price
    newLockerItem["total"] = quantity * price;
    lockerData.push(newLockerItem);
    $.cookie("locker-data", JSON.stringify(lockerData), { path: '/' });
    alert("This item has been added to your custom locker!");
  };

  function getProduct(url) {
    var productData = null
    console.log('sending request to', url)
    $.ajax({
      url: url + '.json',
      dataType: "json",
      async: false,
      success: function(data) {
        productData = data.product
      }
    });
    return productData
  }

  function getPrice(product, quantity) {
    var use_price = 0;
    var lastQuantity = 0;
    var variant_min_quantity;
    $.each(product.variants, function(index,value) {
      // get quantity of variant
      variant_min_quantity = parseInt(value.title.replace('+', ''));
      // if greater than last quantity then grab price
      if (variant_min_quantity <= parseInt(quantity)) {
        use_price = parseFloat(value.price);
      }
    });
    return use_price;
  }

      $(document).ready(getPriceTable);

  function getPriceTable() {
    var element = $('#custompricetable')
    var priceTableProductUrl = element.data('productUrl')
    console.log('running with url', priceTableProductUrl)
    $.ajax({
      url: priceTableProductUrl + '.json',
      dataType: "json",
      async: false,
      success: function(data) {
        var html = '<table class="shappify_qb_grid"><thead><tr><th>Quantity</th><th>Price</th></tr></thead><tbody>'
        var curLow;
        var highQuant;
        var price;
        var newRow;
      	// check if title variant exists before continuing;
      	console.log(data.product.variants.length);
      	console.log(data.product.variants);
      	// if Quantity
      if (data.product.variants[0].option1 == "Default Title" ) {
        console.log("product has single price");
       // do a single thing here
      	html += '<tr><td>8+</td><td>$' + data.product.variants[0].price + '</td></tr>'

      } else {
        $.each(data.product.variants, function(index,value) {
          // get quantity of variant
          highQuant = parseInt(value.title.replace('+', ''));
          if (curLow) {
            newRow = '<tr><td>' + curLow + ' - ' + (highQuant - 1) + '</td><td>$' + price + '</td></tr>'
            console.log(newRow);
            html += newRow;
          }
          price = parseFloat(value.price);
          curLow = highQuant;
        });
        html += '<tr><td>' + curLow + ' +</td><td>$' + price + '</td></tr>'
      }
        html += '</tbody></table>'
        console.log(html)
        $('#custompricetable').html(html);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teamstore-search"] && !Shopify.designMode) return;
  try {
    
  var baseUrl = 'sbr-med.myshopify.com'
  console.log('doing its thing')
  $('#teamstore-search-form').submit(function(event){
    event.preventDefault()
    var storeName = $('#teamstore_name').val();
    var storePass = $('#teamstore_pass').val();
    console.log('form submitting', storeName, storePass)
    var passcheckurl = 'https://prodo-server.herokuapp.com/shopifyproxy/teamstorecheck?shop=' + baseUrl + '&teamstoreName='+ storeName + '&teamstorePass=' + storePass
    $.ajax({
      url: passcheckurl,
      type: 'GET',
      success: function (result,status,xhr) {
        console.log('teamstore url', result)
        location.href = result
      },
      error: function (xhr, ajaxOptions, thrownError) {
        alert('Teamstore or Password incorrect');
      }
    })
    return false;
  });

  function storeNamesAutocomplete(inp) {
    console.log('setting up store auto complete')
    var currentFocus;
    var debounce = null;
    /*execute a function when someone writes in the text field:*/
    inp.addEventListener("input", function(e) {
      console.log('input listener', this.value)
      var inputElement = this
      var a, b, i, val = this.value;
      clearTimeout(debounce);
      if (!val) { return false;}
      var searchUrl = 'https://prodo-server.herokuapp.com/shopifyproxy/teamstoresearch?shop=' + baseUrl + '&query=' + val
      console.log('getting teamstores with url', searchUrl)
      debounce = setTimeout(function(){
        $.ajax({
          url: searchUrl,
          type: 'GET',
          success: function (result,status,xhr) {
            closeAllLists();
            console.log('teamstores', result)
            currentFocus = -1;
            /*create a DIV element that will contain the items (values):*/
            a = document.createElement("DIV");
            a.setAttribute("id", inputElement.id + "autocomplete-list");
            a.setAttribute("class", "autocomplete-items");
            /*append the DIV element as a child of the autocomplete container:*/
            inputElement.parentNode.appendChild(a);
            if (!result) {
              return
            }
            for (i = 0; i < result.length; i++) {
              /*create a DIV element for each matching element:*/
              b = document.createElement("DIV");
              b.innerHTML = result[i];
              b.innerHTML += "<input type='hidden' value='" + result[i] + "'>";
              b.addEventListener("click", function(e) {
                inp.value = this.getElementsByTagName("input")[0].value;
                closeAllLists();
              });
              a.appendChild(b);
            }
          },
        })
      }, 500);
    });

    inp.addEventListener("keydown", function(e) {
        var x = document.getElementById(this.id + "autocomplete-list");
        if (x) x = x.getElementsByTagName("div");
        if (e.keyCode == 40) {
          /*If the arrow DOWN key is pressed,
          increase the currentFocus variable:*/
          currentFocus++;
          /*and and make the current item more visible:*/
          addActive(x);
        } else if (e.keyCode == 38) { //up
          /*If the arrow UP key is pressed,
          decrease the currentFocus variable:*/
          currentFocus--;
          /*and and make the current item more visible:*/
          addActive(x);
        } else if (e.keyCode == 13) {
          /*If the ENTER key is pressed, prevent the form from being submitted,*/
          e.preventDefault();
          if (currentFocus > -1) {
            /*and simulate a click on the "active" item:*/
            if (x) x[currentFocus].click();
          }
        }
    });

    function addActive(x) {
      /*a function to classify an item as "active":*/
      if (!x) return false;
      /*start by removing the "active" class on all items:*/
      removeActive(x);
      if (currentFocus >= x.length) currentFocus = 0;
      if (currentFocus < 0) currentFocus = (x.length - 1);
      /*add class "autocomplete-active":*/
      x[currentFocus].classList.add("autocomplete-active");
    }
    function removeActive(x) {
      /*a function to remove the "active" class from all autocomplete items:*/
      for (var i = 0; i < x.length; i++) {
        x[i].classList.remove("autocomplete-active");
      }
    }
    function closeAllLists(elmnt) {
      /*close all autocomplete lists in the document,
      except the one passed as an argument:*/
      var x = document.getElementsByClassName("autocomplete-items");
      for (var i = 0; i < x.length; i++) {
        if (elmnt != x[i] && elmnt != inp) {
          x[i].parentNode.removeChild(x[i]);
        }
      }
    }

    /*execute a function when someone clicks in the document:*/
    document.addEventListener("click", function (e) {
        closeAllLists(e.target);
    });
  }

  storeNamesAutocomplete(document.getElementById("teamstore_name"));

  } catch(e) { console.error(e); }
})();
})();
